/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/resources/js/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 896);
/******/ })
/************************************************************************/
/******/ ({

/***/ 1:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 149:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{ id: '1', name: '北海道', areaId: '01' }, { id: '2', name: '青森', areaId: '02' }, { id: '3', name: '岩手', areaId: '02' }, { id: '4', name: '宮城', areaId: '02' }, { id: '5', name: '秋田', areaId: '02' }, { id: '6', name: '山形', areaId: '02' }, { id: '7', name: '福島', areaId: '02' }, { id: '8', name: '茨城', areaId: '03' }, { id: '9', name: '栃木', areaId: '03' }, { id: '10', name: '群馬', areaId: '03' }, { id: '11', name: '埼玉', areaId: '04' }, { id: '12', name: '千葉', areaId: '04' }, { id: '13', name: '東京', areaId: '04' }, { id: '14', name: '神奈川', areaId: '04' }, { id: '15', name: '新潟', areaId: '03' }, { id: '16', name: '富山', areaId: '05' }, { id: '17', name: '石川', areaId: '05' }, { id: '18', name: '福井', areaId: '05' }, { id: '19', name: '山梨', areaId: '04' }, { id: '20', name: '長野', areaId: '06' }, { id: '21', name: '岐阜', areaId: '06' }, { id: '22', name: '静岡', areaId: '06' }, { id: '23', name: '愛知', areaId: '06' }, { id: '24', name: '三重', areaId: '06' }, { id: '25', name: '滋賀', areaId: '07' }, { id: '26', name: '京都', areaId: '07' }, { id: '27', name: '大阪', areaId: '07' }, { id: '28', name: '兵庫', areaId: '07' }, { id: '29', name: '奈良', areaId: '07' }, { id: '30', name: '和歌山', areaId: '07' }, { id: '31', name: '鳥取', areaId: '08' }, { id: '32', name: '島根', areaId: '08' }, { id: '33', name: '岡山', areaId: '08' }, { id: '34', name: '広島', areaId: '08' }, { id: '35', name: '山口', areaId: '08' }, { id: '36', name: '徳島', areaId: '08' }, { id: '37', name: '香川', areaId: '08' }, { id: '38', name: '愛媛', areaId: '08' }, { id: '39', name: '高知', areaId: '08' }, { id: '40', name: '福岡', areaId: '09' }, { id: '41', name: '佐賀', areaId: '09' }, { id: '42', name: '長崎', areaId: '09' }, { id: '43', name: '熊本', areaId: '09' }, { id: '44', name: '大分', areaId: '09' }, { id: '45', name: '宮崎', areaId: '09' }, { id: '46', name: '鹿児島', areaId: '09' }, { id: '47', name: '沖縄', areaId: '09' }];

/***/ }),

/***/ 151:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _JudgementInfo = __webpack_require__(152);

var _JudgementInfo2 = _interopRequireDefault(_JudgementInfo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _JudgementInfo2.default;

/***/ }),

/***/ 152:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jssha = __webpack_require__(153);

var _jssha2 = _interopRequireDefault(_jssha);

var _MockSubject = __webpack_require__(76);

var _MockSubject2 = _interopRequireDefault(_MockSubject);

var _judgementInfoCategories = __webpack_require__(154);

var _judgementInfoCategories2 = _interopRequireDefault(_judgementInfoCategories);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var FETCH_TIMEOUT = 30000;
var DEFAULT_API_PARAMS = {
  nendo: '', // 設定ファイルから取得。 商品年度 - 入試年度ではなく年度なのでDN2019は「2018」年度更新
  gakunen: '3', // 商品学年 - 固定値「3」
  kai: '8', // 商品回 - 固定値「8」
  schoolCd: '99999', // 学校CD - 固定「99999」
  moshiSiboList: [] // これは空配列を渡さないとダメっぽい、、、
};
var NEED_FIRST_CHOICE_MAP = {
  soci: { groupId: '1_2' }, // 地歴公民
  scie: { groupId: '6', uses: ['513', '523', '533', '543'] } // 理科
};

// ここで定義されている科目についてはパラメータ生成の際、
// 他の科目の得点を参照したり後処理をする
var MARK_INFO_RELATION_MAP = {
  '224': { targets: ['902', '903'] },
  '301': { targets: ['911', '912', '913', '914'] }
};

var JudgementInfo = function () {
  _createClass(JudgementInfo, [{
    key: 'mockIsReady',
    get: function get() {
      return this.mockState === 'ready';
    }
  }, {
    key: 'mockIsNotReady',
    get: function get() {
      return this.mockState === 'notready';
    }
  }, {
    key: 'selfcheckIsReady',
    get: function get() {
      return this.selfcheckState === 'ready';
    }
  }, {
    key: 'selfcheckIsNotReady',
    get: function get() {
      return this.selfcheckState === 'notready';
    }
  }, {
    key: 'firstChoiceIsReady',
    get: function get() {
      return this.firstChoiceState === 'ready';
    }
  }, {
    key: 'firstChoiceIsNotReady',
    get: function get() {
      return this.firstChoiceState === 'notready';
    }
  }, {
    key: 'isReady',
    get: function get() {
      return this.mockIsReady && this.selfcheckIsReady && this.firstChoiceIsReady;
    }

    /**
     * constructor
     */

  }], [{
    key: 'createCacheHashByParams',
    value: function createCacheHashByParams(params) {
      var sha = new _jssha2.default('SHA-1', 'TEXT');
      sha.update(JSON.stringify(params));
      return sha.getHash('HEX');
    }
  }]);

  function JudgementInfo() {
    var year = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : dn.$store.getters['config/year'];

    _classCallCheck(this, JudgementInfo);

    this.year = year;

    this.subjectCategories = _judgementInfoCategories2.default;
    this.mock = new _MockSubject2.default();
    this.subjectsParams = null;
    this.cacheHash = null;
    this.mockState = 'pending';
    this.selfcheckState = 'pending';
    this.firstChoiceState = 'pending';
    this.firstChoiceErrors = [];

    var debugQuery = dn.$store.state.route.query.jidebug;
    this.isDebug = debugQuery !== undefined;
    this.isDebugError = debugQuery === 'error';
    this.isDebugSleep = debugQuery ? !!debugQuery.match(/^\d+$/) : false;
    this.debugSleepAmmount = this.isDebugSleep ? parseFloat(debugQuery) : 0;
    this.useCache = !this.isDebug;
  }

  /**
   * 初期化
   */


  _createClass(JudgementInfo, [{
    key: 'init',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Promise.all([this.mock.load(), dn.$store.dispatch('selfcheck/load')]);

              case 2:
                _context.next = 4;
                return this.updateHistories();

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function init() {
        return _ref.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: 'updateHistories',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.mock.restoreHistories();
                this.updateSubjectsParams();

              case 2:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function updateHistories() {
        return _ref2.apply(this, arguments);
      }

      return updateHistories;
    }()
  }, {
    key: 'getApiParams',
    value: function getApiParams() {
      var _this = this;

      var cache = this.getCache();
      var schoolChoices = dn.segments.schoolChoices.find();
      var cmpsSiboList = [];

      schoolChoices.forEach(function (choice) {
        if (_this.useCache) {
          if (!cache.judgements[choice]) cmpsSiboList.push({ bosyutaniCd: choice });
        } else {
          cmpsSiboList.push({ bosyutaniCd: choice });
        }
      });

      if (!cmpsSiboList.length) {
        return 'cacheonly';
      }

      return Object.assign(DEFAULT_API_PARAMS, this.subjectsParams, { cmpsSiboList: cmpsSiboList });
    }
  }, {
    key: 'fetch',
    value: function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var params, url, promiseList, res, err, cache;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.isReady) {
                  _context3.next = 3;
                  break;
                }

                console.warn(this);
                throw new Error('APIリクエストの準備が完了していません。');

              case 3:

                // 判定APIに渡す年度情報を設定ファイルから取得
                DEFAULT_API_PARAMS.nendo = dn.$store.getters['config/judgementApiNendo'];

                params = this.getApiParams();

                if (!(params !== 'cacheonly')) {
                  _context3.next = 23;
                  break;
                }

                _context3.next = 8;
                return dn.$store.dispatch('config/ready');

              case 8:
                url = dn.$store.getters['config/judgementApiUrl'];


                if (this.isDebug) {
                  console.group('判定API送信データ');
                  console.log(JSON.stringify(params, null, '  '));
                  console.groupEnd();
                }

                if (!this.isDebugError) {
                  _context3.next = 12;
                  break;
                }

                throw new Error('URLパラメータでエラー設定が行われているので、強制的に失敗します');

              case 12:
                promiseList = [dn.$http.post(url, {
                  timeout: FETCH_TIMEOUT,
                  dataType: 'json',
                  contentType: 'application/json; charset=utf-8',
                  data: JSON.stringify(params)
                })];


                if (this.isDebugSleep) {
                  console.log('\u30C7\u30D0\u30C3\u30B0\u5024\u304C\u8A2D\u5B9A\u3055\u308C\u3066\u3044\u308B\u306E\u3067\u6700\u4F4E' + this.debugSleepAmmount + '\u79D2\u30B9\u30EA\u30FC\u30D7\u3057\u307E\u3059');
                  promiseList.push(dn.$dn.sleep(this.debugSleepAmmount * 1000));
                }

                _context3.next = 16;
                return Promise.all(promiseList);

              case 16:
                res = _context3.sent[0].data;


                if (this.isDebug) {
                  console.group('判定APIレスポンスデータ');
                  console.log(JSON.stringify(res, null, '  '));
                  console.groupEnd();
                }

                if (!(res.result !== 0)) {
                  _context3.next = 22;
                  break;
                }

                err = new Error('判定APIのレスポンスが不正です');

                err.name = 'dn-judgement-api-error';
                throw new Error(err);

              case 22:

                this.setCache(res.cmpsSiboList);

              case 23:
                cache = this.getCache();
                return _context3.abrupt('return', cache.judgements);

              case 25:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function fetch() {
        return _ref3.apply(this, arguments);
      }

      return fetch;
    }()
  }, {
    key: 'setCache',
    value: function setCache(cmpsSiboList) {
      if (dn.$store.getters['config/isManabi']) {
        var cache = this.getCache();
        cmpsSiboList.forEach(function (row) {
          var rtnStatusCd = row.rtnStatusCd;
          if (rtnStatusCd !== '50' && rtnStatusCd !== '00' && rtnStatusCd !== '000' && rtnStatusCd !== '050') {
            console.warn(row);
            throw new Error('Compass志望校情報のレスポンスが不正です');
          }

          var judgement = {
            isMissing: row.rtnStatusCd === '50',
            bosyutaniCd: row.bosyutaniCd,
            allentFlg: row.allentFlg,
            centerFlg: row.centerFlg,
            deciDK: {
              rank: row.deciDK.rank,
              dev: row.deciDK.dev,
              rankABase: row.deciDK.rankABase,
              rankBBase: row.deciDK.rankBBase,
              rankCBase: row.deciDK.rankCBase,
              rankDBase: row.deciDK.rankDBase,
              rankUpRank: row.deciDK.rankUpRank,
              rankUpDev: row.deciDK.rankUpDev
            },
            deciList: []
          };
          for (var i = 0; i < 2; i++) {
            var deci = row.deciList[i];
            judgement.deciList.push({
              rank: deci.rank,
              dev: deci.dev,
              rankABase: deci.rankABase,
              rankBBase: deci.rankBBase,
              rankCBase: deci.rankCBase,
              rankDBase: deci.rankDBase,
              rankUpRank: deci.rankUpRank,
              rankUpScore: deci.rankUpScore,
              japSelSubj: deci.japSelSubj,
              mathSelSubj: deci.mathSelSubj,
              engSelSubj: deci.engSelSubj,
              sociSelSubj: deci.sociSelSubj,
              scieSelSubj: deci.scieSelSubj,
              biko: deci.biko,
              niDankai: deci.niDankai
            });
          }
          cache.judgements[row.bosyutaniCd] = judgement;
        });
        dn.$ls.set('judgement_cache', cache);
        return cache;
      } else {
        var _cache = this.getCache();
        cmpsSiboList.forEach(function (row) {
          if (row.rtnStatusCd !== '50' && row.rtnStatusCd !== '00') {
            console.warn(row);
            throw new Error('Compass志望校情報のレスポンスが不正です');
          }

          var judgement = {
            isMissing: row.rtnStatusCd === '50',
            bosyutaniCd: row.bosyutaniCd,
            allentFlg: row.allentFlg,
            deciDK: {
              rank: row.deciDK.rank,
              rankUpRank: row.deciDK.rankUpRank,
              rankUpDev: row.deciDK.rankUpDev
            },
            deciList: []
          };
          for (var i = 0; i < 2; i++) {
            var deci = row.deciList[i];
            judgement.deciList.push({
              rank: deci.rank,
              dev: deci.dev,
              rankABase: deci.rankABase,
              rankBBase: deci.rankBBase,
              rankCBase: deci.rankCBase,
              rankDBase: deci.rankDBase,
              rankUpRank: deci.rankUpRank,
              rankUpScore: deci.rankUpScore,
              japSelSubj: deci.japSelSubj,
              mathSelSubj: deci.mathSelSubj,
              engSelSubj: deci.engSelSubj,
              sociSelSubj: deci.sociSelSubj,
              scieSelSubj: deci.scieSelSubj,
              biko: deci.biko,
              niDankai: deci.niDankai
            });
          }
          _cache.judgements[row.bosyutaniCd] = judgement;
        });
        dn.$ls.set('judgement_cache', _cache);
        return _cache;
      }
    }
  }, {
    key: 'getCache',
    value: function getCache() {
      var cache = JSON.parse(JSON.stringify(dn.$ls.get('judgement_cache', {
        hash: this.cacheHash,
        judgements: {}
      })));

      if (cache.hash !== this.cacheHash) {
        return this.initializeCache();
      }

      return cache;
    }
  }, {
    key: 'updateCacheHash',
    value: function updateCacheHash() {
      this.cacheHash = this.constructor.createCacheHashByParams(this.subjectsParams);
      var cache = JSON.parse(JSON.stringify(dn.$ls.get('judgement_cache', {})));
      if (cache.hash !== this.cacheHash) {
        this.initializeCache(this.cacheHash);
      }
    }
  }, {
    key: 'initializeCache',
    value: function initializeCache(hash) {
      var cache = {
        hash: hash,
        judgements: {}
      };
      dn.$ls.set('judgement_cache', cache);
      return cache;
    }
  }, {
    key: 'updateSubjectsParams',
    value: function updateSubjectsParams() {
      var _this2 = this;

      this.mockState = 'notready';
      this.selfcheckState = 'notready';
      this.firstChoiceState = 'notready';
      this.subjectsParams = this.getSubjectsParams();

      this.updateCacheHash();

      // 模試科目は1つも送信しないでもOKなので常にready
      this.mockState = 'ready';

      this.firstChoiceErrors = [];

      var _loop = function _loop(key) {
        var selects = _this2.subjectsParams.markInfoScore[key];
        if (NEED_FIRST_CHOICE_MAP[key].uses) {
          selects = selects.filter(function (select) {
            return NEED_FIRST_CHOICE_MAP[key].uses.includes(select.subjCd);
          });
        }

        if (!selects.length) return 'continue';

        var groupId = NEED_FIRST_CHOICE_MAP[key].groupId;
        var choice = dn.$store.getters['selfcheck/groupedCategoryFirstChoice'](groupId);
        if (!choice) _this2.firstChoiceErrors.push({
          key: key,
          groupId: groupId,
          name: dn.$store.getters['selfcheck/groupedCategoryById'](groupId).name
        });
      };

      for (var key in NEED_FIRST_CHOICE_MAP) {
        var _ret = _loop(key);

        if (_ret === 'continue') continue;
      }
      if (!this.firstChoiceErrors.length) {
        this.firstChoiceState = 'ready';
      }

      for (var key in this.subjectsParams.markInfoScore) {
        if (this.subjectsParams.markInfoScore[key].length) {
          this.selfcheckState = 'ready';
          break;
        }
      }
    }
  }, {
    key: 'getSubjectsParams',
    value: function getSubjectsParams() {
      var descInformations = this.getDescInformations();
      var markInfoScore = this.getMarkInfoScore();
      var params = Object.assign({
        markInfoScore: markInfoScore
      }, descInformations);
      return params;
    }
  }, {
    key: 'sortApiParamsSubjects',
    value: function sortApiParamsSubjects(subjects) {
      subjects.sort(function (a, b) {
        return parseInt(a.subjCd) > parseInt(b.subjCd) ? 1 : -1;
      });
    }
  }, {
    key: 'getRelationMarkInfoScore',
    value: function getRelationMarkInfoScore(originId) {
      var relationScore = void 0;
      var mapping = MARK_INFO_RELATION_MAP[originId];
      if (mapping) {
        var ids = [originId].concat(_toConsumableArray(mapping.targets));
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = ids[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var id = _step.value;

            var history = dn.$store.getters['selfcheck/subjectHistory'](id);
            var score = !history.selected || !history.fixed ? null : history.score;
            if (score) {
              relationScore = {
                id: id,
                score: score
              };
              break;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      if (!relationScore) {
        var _history = dn.$store.getters['selfcheck/subjectHistory'](originId);
        var _score = !_history.selected || !_history.fixed ? null : _history.score;
        relationScore = {
          id: originId,
          score: _score
        };
      }
      return relationScore;
    }
  }, {
    key: 'getMarkInfoScore',
    value: function getMarkInfoScore() {
      var _this3 = this;

      var markInfoScore = {};

      /**
       * リスニング得点一時変数
       * 英語以外の外国語を選択していた際に、2で割って四捨五入された得点がループの中で代入される
       * 後続のリスニング得点算出用に利用する
       */
      var listeningScore = null;

      this.subjectCategories.forEach(function (category) {
        markInfoScore[category.id] = [];

        category.center.forEach(function (id) {
          if (id === '311' && listeningScore !== null) {

            markInfoScore[category.id].push({ subjCd: id, score: String(listeningScore) });
            return;
          }

          var relation = _this3.getRelationMarkInfoScore(id);
          var score = relation.score;
          if (score !== null) {

            /**
             * @MEMO
             * 英語以外の外国語を採用済みのときはその点数からリーディング＆リスニング得点を設定する
             * 2021年度の改定にあたって、リスニング含め英語の満点値が変更→200, 50から 100, 100となる
             */
            if (id === '301' && relation.id !== '301') {
              // >>> 判定送信対象が英語、かつ取ってきた得点が英語じゃない外国語だった時
              // 自身のスコアを2で割り＆四捨五入しておき、後続ループで発生するリスニングスコアを代入しておく
              var originalScore = score;
              score = Math.round(score / 2);
              listeningScore = originalScore - score;
            }
            markInfoScore[category.id].push({ subjCd: id, score: String(score) });
          }
        });

        _this3.sortApiParamsSubjects(markInfoScore[category.id]);

        if (NEED_FIRST_CHOICE_MAP[category.id]) {
          var groupId = NEED_FIRST_CHOICE_MAP[category.id].groupId;
          var choice = dn.$store.getters['selfcheck/groupedCategoryFirstChoice'](groupId);

          if (choice) {
            markInfoScore[category.id].sort(function (a, b) {
              return a.subjCd === choice ? -1 : 1;
            });
          }
        }
      });

      return markInfoScore;
    }
  }, {
    key: 'getDescInformations',
    value: function getDescInformations() {
      var _this4 = this;

      var info = {
        descInfo: {},
        descInfoScore: {}
      };

      this.subjectCategories.forEach(function (category) {
        info.descInfo[category.id] = [];
        info.descInfoScore[category.id] = [];

        category.mock.forEach(function (id) {
          var history = _this4.mock.histories[id];
          if (history.score === null) return;
          info.descInfo[category.id].push({ subjCd: id, score: String(Math.round(history.deviation * 10)) });
          info.descInfoScore[category.id].push({ subjCd: id, score: String(history.score) });
        });

        _this4.sortApiParamsSubjects(info.descInfo[category.id]);
        _this4.sortApiParamsSubjects(info.descInfoScore[category.id]);
      });

      return info;
    }
  }]);

  return JudgementInfo;
}();

JudgementInfo.subjectCategories = _judgementInfoCategories2.default;
exports.default = JudgementInfo;

/***/ }),

/***/ 153:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_RESULT__;/*
 A JavaScript implementation of the SHA family of hashes, as
 defined in FIPS PUB 180-4 and FIPS PUB 202, as well as the corresponding
 HMAC implementation as defined in FIPS PUB 198a

 Copyright Brian Turek 2008-2017
 Distributed under the BSD License
 See http://caligatio.github.com/jsSHA/ for more information

 Several functions taken from Paul Johnston
*/
(function(Y){function C(c,a,b){var e=0,h=[],n=0,g,l,d,f,m,q,u,r,I=!1,v=[],w=[],t,y=!1,z=!1,x=-1;b=b||{};g=b.encoding||"UTF8";t=b.numRounds||1;if(t!==parseInt(t,10)||1>t)throw Error("numRounds must a integer >= 1");if("SHA-1"===c)m=512,q=K,u=Z,f=160,r=function(a){return a.slice()};else if(0===c.lastIndexOf("SHA-",0))if(q=function(a,b){return L(a,b,c)},u=function(a,b,h,e){var k,f;if("SHA-224"===c||"SHA-256"===c)k=(b+65>>>9<<4)+15,f=16;else if("SHA-384"===c||"SHA-512"===c)k=(b+129>>>10<<
5)+31,f=32;else throw Error("Unexpected error in SHA-2 implementation");for(;a.length<=k;)a.push(0);a[b>>>5]|=128<<24-b%32;b=b+h;a[k]=b&4294967295;a[k-1]=b/4294967296|0;h=a.length;for(b=0;b<h;b+=f)e=L(a.slice(b,b+f),e,c);if("SHA-224"===c)a=[e[0],e[1],e[2],e[3],e[4],e[5],e[6]];else if("SHA-256"===c)a=e;else if("SHA-384"===c)a=[e[0].a,e[0].b,e[1].a,e[1].b,e[2].a,e[2].b,e[3].a,e[3].b,e[4].a,e[4].b,e[5].a,e[5].b];else if("SHA-512"===c)a=[e[0].a,e[0].b,e[1].a,e[1].b,e[2].a,e[2].b,e[3].a,e[3].b,e[4].a,
e[4].b,e[5].a,e[5].b,e[6].a,e[6].b,e[7].a,e[7].b];else throw Error("Unexpected error in SHA-2 implementation");return a},r=function(a){return a.slice()},"SHA-224"===c)m=512,f=224;else if("SHA-256"===c)m=512,f=256;else if("SHA-384"===c)m=1024,f=384;else if("SHA-512"===c)m=1024,f=512;else throw Error("Chosen SHA variant is not supported");else if(0===c.lastIndexOf("SHA3-",0)||0===c.lastIndexOf("SHAKE",0)){var F=6;q=D;r=function(a){var c=[],e;for(e=0;5>e;e+=1)c[e]=a[e].slice();return c};x=1;if("SHA3-224"===
c)m=1152,f=224;else if("SHA3-256"===c)m=1088,f=256;else if("SHA3-384"===c)m=832,f=384;else if("SHA3-512"===c)m=576,f=512;else if("SHAKE128"===c)m=1344,f=-1,F=31,z=!0;else if("SHAKE256"===c)m=1088,f=-1,F=31,z=!0;else throw Error("Chosen SHA variant is not supported");u=function(a,c,e,b,h){e=m;var k=F,f,g=[],n=e>>>5,l=0,d=c>>>5;for(f=0;f<d&&c>=e;f+=n)b=D(a.slice(f,f+n),b),c-=e;a=a.slice(f);for(c%=e;a.length<n;)a.push(0);f=c>>>3;a[f>>2]^=k<<f%4*8;a[n-1]^=2147483648;for(b=D(a,b);32*g.length<h;){a=b[l%
5][l/5|0];g.push(a.b);if(32*g.length>=h)break;g.push(a.a);l+=1;0===64*l%e&&D(null,b)}return g}}else throw Error("Chosen SHA variant is not supported");d=M(a,g,x);l=A(c);this.setHMACKey=function(a,b,h){var k;if(!0===I)throw Error("HMAC key already set");if(!0===y)throw Error("Cannot set HMAC key after calling update");if(!0===z)throw Error("SHAKE is not supported for HMAC");g=(h||{}).encoding||"UTF8";b=M(b,g,x)(a);a=b.binLen;b=b.value;k=m>>>3;h=k/4-1;if(k<a/8){for(b=u(b,a,0,A(c),f);b.length<=h;)b.push(0);
b[h]&=4294967040}else if(k>a/8){for(;b.length<=h;)b.push(0);b[h]&=4294967040}for(a=0;a<=h;a+=1)v[a]=b[a]^909522486,w[a]=b[a]^1549556828;l=q(v,l);e=m;I=!0};this.update=function(a){var c,b,k,f=0,g=m>>>5;c=d(a,h,n);a=c.binLen;b=c.value;c=a>>>5;for(k=0;k<c;k+=g)f+m<=a&&(l=q(b.slice(k,k+g),l),f+=m);e+=f;h=b.slice(f>>>5);n=a%m;y=!0};this.getHash=function(a,b){var k,g,d,m;if(!0===I)throw Error("Cannot call getHash after setting HMAC key");d=N(b);if(!0===z){if(-1===d.shakeLen)throw Error("shakeLen must be specified in options");
f=d.shakeLen}switch(a){case "HEX":k=function(a){return O(a,f,x,d)};break;case "B64":k=function(a){return P(a,f,x,d)};break;case "BYTES":k=function(a){return Q(a,f,x)};break;case "ARRAYBUFFER":try{g=new ArrayBuffer(0)}catch(p){throw Error("ARRAYBUFFER not supported by this environment");}k=function(a){return R(a,f,x)};break;default:throw Error("format must be HEX, B64, BYTES, or ARRAYBUFFER");}m=u(h.slice(),n,e,r(l),f);for(g=1;g<t;g+=1)!0===z&&0!==f%32&&(m[m.length-1]&=16777215>>>24-f%32),m=u(m,f,
0,A(c),f);return k(m)};this.getHMAC=function(a,b){var k,g,d,p;if(!1===I)throw Error("Cannot call getHMAC without first setting HMAC key");d=N(b);switch(a){case "HEX":k=function(a){return O(a,f,x,d)};break;case "B64":k=function(a){return P(a,f,x,d)};break;case "BYTES":k=function(a){return Q(a,f,x)};break;case "ARRAYBUFFER":try{k=new ArrayBuffer(0)}catch(v){throw Error("ARRAYBUFFER not supported by this environment");}k=function(a){return R(a,f,x)};break;default:throw Error("outputFormat must be HEX, B64, BYTES, or ARRAYBUFFER");
}g=u(h.slice(),n,e,r(l),f);p=q(w,A(c));p=u(g,f,m,p,f);return k(p)}}function b(c,a){this.a=c;this.b=a}function O(c,a,b,e){var h="";a/=8;var n,g,d;d=-1===b?3:0;for(n=0;n<a;n+=1)g=c[n>>>2]>>>8*(d+n%4*b),h+="0123456789abcdef".charAt(g>>>4&15)+"0123456789abcdef".charAt(g&15);return e.outputUpper?h.toUpperCase():h}function P(c,a,b,e){var h="",n=a/8,g,d,p,f;f=-1===b?3:0;for(g=0;g<n;g+=3)for(d=g+1<n?c[g+1>>>2]:0,p=g+2<n?c[g+2>>>2]:0,p=(c[g>>>2]>>>8*(f+g%4*b)&255)<<16|(d>>>8*(f+(g+1)%4*b)&255)<<8|p>>>8*(f+
(g+2)%4*b)&255,d=0;4>d;d+=1)8*g+6*d<=a?h+="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(p>>>6*(3-d)&63):h+=e.b64Pad;return h}function Q(c,a,b){var e="";a/=8;var h,d,g;g=-1===b?3:0;for(h=0;h<a;h+=1)d=c[h>>>2]>>>8*(g+h%4*b)&255,e+=String.fromCharCode(d);return e}function R(c,a,b){a/=8;var e,h=new ArrayBuffer(a),d,g;g=new Uint8Array(h);d=-1===b?3:0;for(e=0;e<a;e+=1)g[e]=c[e>>>2]>>>8*(d+e%4*b)&255;return h}function N(c){var a={outputUpper:!1,b64Pad:"=",shakeLen:-1};c=c||{};
a.outputUpper=c.outputUpper||!1;!0===c.hasOwnProperty("b64Pad")&&(a.b64Pad=c.b64Pad);if(!0===c.hasOwnProperty("shakeLen")){if(0!==c.shakeLen%8)throw Error("shakeLen must be a multiple of 8");a.shakeLen=c.shakeLen}if("boolean"!==typeof a.outputUpper)throw Error("Invalid outputUpper formatting option");if("string"!==typeof a.b64Pad)throw Error("Invalid b64Pad formatting option");return a}function M(c,a,b){switch(a){case "UTF8":case "UTF16BE":case "UTF16LE":break;default:throw Error("encoding must be UTF8, UTF16BE, or UTF16LE");
}switch(c){case "HEX":c=function(a,c,d){var g=a.length,l,p,f,m,q,u;if(0!==g%2)throw Error("String of HEX type must be in byte increments");c=c||[0];d=d||0;q=d>>>3;u=-1===b?3:0;for(l=0;l<g;l+=2){p=parseInt(a.substr(l,2),16);if(isNaN(p))throw Error("String of HEX type contains invalid characters");m=(l>>>1)+q;for(f=m>>>2;c.length<=f;)c.push(0);c[f]|=p<<8*(u+m%4*b)}return{value:c,binLen:4*g+d}};break;case "TEXT":c=function(c,h,d){var g,l,p=0,f,m,q,u,r,t;h=h||[0];d=d||0;q=d>>>3;if("UTF8"===a)for(t=-1===
b?3:0,f=0;f<c.length;f+=1)for(g=c.charCodeAt(f),l=[],128>g?l.push(g):2048>g?(l.push(192|g>>>6),l.push(128|g&63)):55296>g||57344<=g?l.push(224|g>>>12,128|g>>>6&63,128|g&63):(f+=1,g=65536+((g&1023)<<10|c.charCodeAt(f)&1023),l.push(240|g>>>18,128|g>>>12&63,128|g>>>6&63,128|g&63)),m=0;m<l.length;m+=1){r=p+q;for(u=r>>>2;h.length<=u;)h.push(0);h[u]|=l[m]<<8*(t+r%4*b);p+=1}else if("UTF16BE"===a||"UTF16LE"===a)for(t=-1===b?2:0,l="UTF16LE"===a&&1!==b||"UTF16LE"!==a&&1===b,f=0;f<c.length;f+=1){g=c.charCodeAt(f);
!0===l&&(m=g&255,g=m<<8|g>>>8);r=p+q;for(u=r>>>2;h.length<=u;)h.push(0);h[u]|=g<<8*(t+r%4*b);p+=2}return{value:h,binLen:8*p+d}};break;case "B64":c=function(a,c,d){var g=0,l,p,f,m,q,u,r,t;if(-1===a.search(/^[a-zA-Z0-9=+\/]+$/))throw Error("Invalid character in base-64 string");p=a.indexOf("=");a=a.replace(/\=/g,"");if(-1!==p&&p<a.length)throw Error("Invalid '=' found in base-64 string");c=c||[0];d=d||0;u=d>>>3;t=-1===b?3:0;for(p=0;p<a.length;p+=4){q=a.substr(p,4);for(f=m=0;f<q.length;f+=1)l="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".indexOf(q[f]),
m|=l<<18-6*f;for(f=0;f<q.length-1;f+=1){r=g+u;for(l=r>>>2;c.length<=l;)c.push(0);c[l]|=(m>>>16-8*f&255)<<8*(t+r%4*b);g+=1}}return{value:c,binLen:8*g+d}};break;case "BYTES":c=function(a,c,d){var g,l,p,f,m,q;c=c||[0];d=d||0;p=d>>>3;q=-1===b?3:0;for(l=0;l<a.length;l+=1)g=a.charCodeAt(l),m=l+p,f=m>>>2,c.length<=f&&c.push(0),c[f]|=g<<8*(q+m%4*b);return{value:c,binLen:8*a.length+d}};break;case "ARRAYBUFFER":try{c=new ArrayBuffer(0)}catch(e){throw Error("ARRAYBUFFER not supported by this environment");}c=
function(a,c,d){var g,l,p,f,m,q;c=c||[0];d=d||0;l=d>>>3;m=-1===b?3:0;q=new Uint8Array(a);for(g=0;g<a.byteLength;g+=1)f=g+l,p=f>>>2,c.length<=p&&c.push(0),c[p]|=q[g]<<8*(m+f%4*b);return{value:c,binLen:8*a.byteLength+d}};break;default:throw Error("format must be HEX, TEXT, B64, BYTES, or ARRAYBUFFER");}return c}function y(c,a){return c<<a|c>>>32-a}function S(c,a){return 32<a?(a-=32,new b(c.b<<a|c.a>>>32-a,c.a<<a|c.b>>>32-a)):0!==a?new b(c.a<<a|c.b>>>32-a,c.b<<a|c.a>>>32-a):c}function w(c,a){return c>>>
a|c<<32-a}function t(c,a){var k=null,k=new b(c.a,c.b);return k=32>=a?new b(k.a>>>a|k.b<<32-a&4294967295,k.b>>>a|k.a<<32-a&4294967295):new b(k.b>>>a-32|k.a<<64-a&4294967295,k.a>>>a-32|k.b<<64-a&4294967295)}function T(c,a){var k=null;return k=32>=a?new b(c.a>>>a,c.b>>>a|c.a<<32-a&4294967295):new b(0,c.a>>>a-32)}function aa(c,a,b){return c&a^~c&b}function ba(c,a,k){return new b(c.a&a.a^~c.a&k.a,c.b&a.b^~c.b&k.b)}function U(c,a,b){return c&a^c&b^a&b}function ca(c,a,k){return new b(c.a&a.a^c.a&k.a^a.a&
k.a,c.b&a.b^c.b&k.b^a.b&k.b)}function da(c){return w(c,2)^w(c,13)^w(c,22)}function ea(c){var a=t(c,28),k=t(c,34);c=t(c,39);return new b(a.a^k.a^c.a,a.b^k.b^c.b)}function fa(c){return w(c,6)^w(c,11)^w(c,25)}function ga(c){var a=t(c,14),k=t(c,18);c=t(c,41);return new b(a.a^k.a^c.a,a.b^k.b^c.b)}function ha(c){return w(c,7)^w(c,18)^c>>>3}function ia(c){var a=t(c,1),k=t(c,8);c=T(c,7);return new b(a.a^k.a^c.a,a.b^k.b^c.b)}function ja(c){return w(c,17)^w(c,19)^c>>>10}function ka(c){var a=t(c,19),k=t(c,61);
c=T(c,6);return new b(a.a^k.a^c.a,a.b^k.b^c.b)}function G(c,a){var b=(c&65535)+(a&65535);return((c>>>16)+(a>>>16)+(b>>>16)&65535)<<16|b&65535}function la(c,a,b,e){var h=(c&65535)+(a&65535)+(b&65535)+(e&65535);return((c>>>16)+(a>>>16)+(b>>>16)+(e>>>16)+(h>>>16)&65535)<<16|h&65535}function H(c,a,b,e,h){var d=(c&65535)+(a&65535)+(b&65535)+(e&65535)+(h&65535);return((c>>>16)+(a>>>16)+(b>>>16)+(e>>>16)+(h>>>16)+(d>>>16)&65535)<<16|d&65535}function ma(c,a){var d,e,h;d=(c.b&65535)+(a.b&65535);e=(c.b>>>16)+
(a.b>>>16)+(d>>>16);h=(e&65535)<<16|d&65535;d=(c.a&65535)+(a.a&65535)+(e>>>16);e=(c.a>>>16)+(a.a>>>16)+(d>>>16);return new b((e&65535)<<16|d&65535,h)}function na(c,a,d,e){var h,n,g;h=(c.b&65535)+(a.b&65535)+(d.b&65535)+(e.b&65535);n=(c.b>>>16)+(a.b>>>16)+(d.b>>>16)+(e.b>>>16)+(h>>>16);g=(n&65535)<<16|h&65535;h=(c.a&65535)+(a.a&65535)+(d.a&65535)+(e.a&65535)+(n>>>16);n=(c.a>>>16)+(a.a>>>16)+(d.a>>>16)+(e.a>>>16)+(h>>>16);return new b((n&65535)<<16|h&65535,g)}function oa(c,a,d,e,h){var n,g,l;n=(c.b&
65535)+(a.b&65535)+(d.b&65535)+(e.b&65535)+(h.b&65535);g=(c.b>>>16)+(a.b>>>16)+(d.b>>>16)+(e.b>>>16)+(h.b>>>16)+(n>>>16);l=(g&65535)<<16|n&65535;n=(c.a&65535)+(a.a&65535)+(d.a&65535)+(e.a&65535)+(h.a&65535)+(g>>>16);g=(c.a>>>16)+(a.a>>>16)+(d.a>>>16)+(e.a>>>16)+(h.a>>>16)+(n>>>16);return new b((g&65535)<<16|n&65535,l)}function B(c,a){return new b(c.a^a.a,c.b^a.b)}function A(c){var a=[],d;if("SHA-1"===c)a=[1732584193,4023233417,2562383102,271733878,3285377520];else if(0===c.lastIndexOf("SHA-",0))switch(a=
[3238371032,914150663,812702999,4144912697,4290775857,1750603025,1694076839,3204075428],d=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225],c){case "SHA-224":break;case "SHA-256":a=d;break;case "SHA-384":a=[new b(3418070365,a[0]),new b(1654270250,a[1]),new b(2438529370,a[2]),new b(355462360,a[3]),new b(1731405415,a[4]),new b(41048885895,a[5]),new b(3675008525,a[6]),new b(1203062813,a[7])];break;case "SHA-512":a=[new b(d[0],4089235720),new b(d[1],2227873595),
new b(d[2],4271175723),new b(d[3],1595750129),new b(d[4],2917565137),new b(d[5],725511199),new b(d[6],4215389547),new b(d[7],327033209)];break;default:throw Error("Unknown SHA variant");}else if(0===c.lastIndexOf("SHA3-",0)||0===c.lastIndexOf("SHAKE",0))for(c=0;5>c;c+=1)a[c]=[new b(0,0),new b(0,0),new b(0,0),new b(0,0),new b(0,0)];else throw Error("No SHA variants supported");return a}function K(c,a){var b=[],e,d,n,g,l,p,f;e=a[0];d=a[1];n=a[2];g=a[3];l=a[4];for(f=0;80>f;f+=1)b[f]=16>f?c[f]:y(b[f-
3]^b[f-8]^b[f-14]^b[f-16],1),p=20>f?H(y(e,5),d&n^~d&g,l,1518500249,b[f]):40>f?H(y(e,5),d^n^g,l,1859775393,b[f]):60>f?H(y(e,5),U(d,n,g),l,2400959708,b[f]):H(y(e,5),d^n^g,l,3395469782,b[f]),l=g,g=n,n=y(d,30),d=e,e=p;a[0]=G(e,a[0]);a[1]=G(d,a[1]);a[2]=G(n,a[2]);a[3]=G(g,a[3]);a[4]=G(l,a[4]);return a}function Z(c,a,b,e){var d;for(d=(a+65>>>9<<4)+15;c.length<=d;)c.push(0);c[a>>>5]|=128<<24-a%32;a+=b;c[d]=a&4294967295;c[d-1]=a/4294967296|0;a=c.length;for(d=0;d<a;d+=16)e=K(c.slice(d,d+16),e);return e}function L(c,
a,k){var e,h,n,g,l,p,f,m,q,u,r,t,v,w,y,A,z,x,F,B,C,D,E=[],J;if("SHA-224"===k||"SHA-256"===k)u=64,t=1,D=Number,v=G,w=la,y=H,A=ha,z=ja,x=da,F=fa,C=U,B=aa,J=d;else if("SHA-384"===k||"SHA-512"===k)u=80,t=2,D=b,v=ma,w=na,y=oa,A=ia,z=ka,x=ea,F=ga,C=ca,B=ba,J=V;else throw Error("Unexpected error in SHA-2 implementation");k=a[0];e=a[1];h=a[2];n=a[3];g=a[4];l=a[5];p=a[6];f=a[7];for(r=0;r<u;r+=1)16>r?(q=r*t,m=c.length<=q?0:c[q],q=c.length<=q+1?0:c[q+1],E[r]=new D(m,q)):E[r]=w(z(E[r-2]),E[r-7],A(E[r-15]),E[r-
16]),m=y(f,F(g),B(g,l,p),J[r],E[r]),q=v(x(k),C(k,e,h)),f=p,p=l,l=g,g=v(n,m),n=h,h=e,e=k,k=v(m,q);a[0]=v(k,a[0]);a[1]=v(e,a[1]);a[2]=v(h,a[2]);a[3]=v(n,a[3]);a[4]=v(g,a[4]);a[5]=v(l,a[5]);a[6]=v(p,a[6]);a[7]=v(f,a[7]);return a}function D(c,a){var d,e,h,n,g=[],l=[];if(null!==c)for(e=0;e<c.length;e+=2)a[(e>>>1)%5][(e>>>1)/5|0]=B(a[(e>>>1)%5][(e>>>1)/5|0],new b(c[e+1],c[e]));for(d=0;24>d;d+=1){n=A("SHA3-");for(e=0;5>e;e+=1){h=a[e][0];var p=a[e][1],f=a[e][2],m=a[e][3],q=a[e][4];g[e]=new b(h.a^p.a^f.a^
m.a^q.a,h.b^p.b^f.b^m.b^q.b)}for(e=0;5>e;e+=1)l[e]=B(g[(e+4)%5],S(g[(e+1)%5],1));for(e=0;5>e;e+=1)for(h=0;5>h;h+=1)a[e][h]=B(a[e][h],l[e]);for(e=0;5>e;e+=1)for(h=0;5>h;h+=1)n[h][(2*e+3*h)%5]=S(a[e][h],W[e][h]);for(e=0;5>e;e+=1)for(h=0;5>h;h+=1)a[e][h]=B(n[e][h],new b(~n[(e+1)%5][h].a&n[(e+2)%5][h].a,~n[(e+1)%5][h].b&n[(e+2)%5][h].b));a[0][0]=B(a[0][0],X[d])}return a}var d,V,W,X;d=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,
1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,
2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];V=[new b(d[0],3609767458),new b(d[1],602891725),new b(d[2],3964484399),new b(d[3],2173295548),new b(d[4],4081628472),new b(d[5],3053834265),new b(d[6],2937671579),new b(d[7],3664609560),new b(d[8],2734883394),new b(d[9],1164996542),new b(d[10],1323610764),new b(d[11],3590304994),new b(d[12],4068182383),new b(d[13],991336113),new b(d[14],633803317),new b(d[15],3479774868),new b(d[16],2666613458),new b(d[17],944711139),new b(d[18],2341262773),
new b(d[19],2007800933),new b(d[20],1495990901),new b(d[21],1856431235),new b(d[22],3175218132),new b(d[23],2198950837),new b(d[24],3999719339),new b(d[25],766784016),new b(d[26],2566594879),new b(d[27],3203337956),new b(d[28],1034457026),new b(d[29],2466948901),new b(d[30],3758326383),new b(d[31],168717936),new b(d[32],1188179964),new b(d[33],1546045734),new b(d[34],1522805485),new b(d[35],2643833823),new b(d[36],2343527390),new b(d[37],1014477480),new b(d[38],1206759142),new b(d[39],344077627),
new b(d[40],1290863460),new b(d[41],3158454273),new b(d[42],3505952657),new b(d[43],106217008),new b(d[44],3606008344),new b(d[45],1432725776),new b(d[46],1467031594),new b(d[47],851169720),new b(d[48],3100823752),new b(d[49],1363258195),new b(d[50],3750685593),new b(d[51],3785050280),new b(d[52],3318307427),new b(d[53],3812723403),new b(d[54],2003034995),new b(d[55],3602036899),new b(d[56],1575990012),new b(d[57],1125592928),new b(d[58],2716904306),new b(d[59],442776044),new b(d[60],593698344),new b(d[61],
3733110249),new b(d[62],2999351573),new b(d[63],3815920427),new b(3391569614,3928383900),new b(3515267271,566280711),new b(3940187606,3454069534),new b(4118630271,4000239992),new b(116418474,1914138554),new b(174292421,2731055270),new b(289380356,3203993006),new b(460393269,320620315),new b(685471733,587496836),new b(852142971,1086792851),new b(1017036298,365543100),new b(1126000580,2618297676),new b(1288033470,3409855158),new b(1501505948,4234509866),new b(1607167915,987167468),new b(1816402316,
1246189591)];X=[new b(0,1),new b(0,32898),new b(2147483648,32906),new b(2147483648,2147516416),new b(0,32907),new b(0,2147483649),new b(2147483648,2147516545),new b(2147483648,32777),new b(0,138),new b(0,136),new b(0,2147516425),new b(0,2147483658),new b(0,2147516555),new b(2147483648,139),new b(2147483648,32905),new b(2147483648,32771),new b(2147483648,32770),new b(2147483648,128),new b(0,32778),new b(2147483648,2147483658),new b(2147483648,2147516545),new b(2147483648,32896),new b(0,2147483649),
new b(2147483648,2147516424)];W=[[0,36,3,41,18],[1,44,10,45,2],[62,6,43,15,61],[28,55,25,21,56],[27,20,39,8,14]]; true?!(__WEBPACK_AMD_DEFINE_RESULT__ = (function(){return C}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!==typeof exports?("undefined"!==typeof module&&module.exports&&(module.exports=C),exports=C):Y.jsSHA=C})(this);


/***/ }),

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var judgementInfoCategories = [{
  id: 'jap',
  mock: ['101', '102', '103', '110', '130'],
  center: ['106', '113', '133', '143']
}, {
  id: 'math',
  mock: ['203', '202', '201'],
  center: ['221', '222', '223', '224']
}, {
  id: 'eng',
  mock: ['301'],
  center: ['301', '311']
}, {
  id: 'soci',
  mock: ['412', '422', '432', '453', '451', '452', '454'],
  center: ['411', '412', '421', '422', '431', '432', '453', '451', '452', '454']
}, {
  id: 'scie',
  mock: ['512', '522', '532', '542', '513', '523', '533', '543'],
  center: ['512', '522', '532', '542', '513', '523', '533', '543']
}];

exports.default = judgementInfoCategories;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Author Tobias Koppers @sokra
  Modified by Evan You @yyx990803
*/

var hasDocument = typeof document !== 'undefined'

if (typeof DEBUG !== 'undefined' && DEBUG) {
  if (!hasDocument) {
    throw new Error(
    'vue-style-loader cannot be used in a non-browser environment. ' +
    "Use { target: 'node' } in your Webpack config to indicate a server-rendering environment."
  ) }
}

var listToStyles = __webpack_require__(8)

/*
type StyleObject = {
  id: number;
  parts: Array<StyleObjectPart>
}

type StyleObjectPart = {
  css: string;
  media: string;
  sourceMap: ?string
}
*/

var stylesInDom = {/*
  [id: number]: {
    id: number,
    refs: number,
    parts: Array<(obj?: StyleObjectPart) => void>
  }
*/}

var head = hasDocument && (document.head || document.getElementsByTagName('head')[0])
var singletonElement = null
var singletonCounter = 0
var isProduction = false
var noop = function () {}
var options = null
var ssrIdKey = 'data-vue-ssr-id'

// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
// tags it will allow on a page
var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\b/.test(navigator.userAgent.toLowerCase())

module.exports = function (parentId, list, _isProduction, _options) {
  isProduction = _isProduction

  options = _options || {}

  var styles = listToStyles(parentId, list)
  addStylesToDom(styles)

  return function update (newList) {
    var mayRemove = []
    for (var i = 0; i < styles.length; i++) {
      var item = styles[i]
      var domStyle = stylesInDom[item.id]
      domStyle.refs--
      mayRemove.push(domStyle)
    }
    if (newList) {
      styles = listToStyles(parentId, newList)
      addStylesToDom(styles)
    } else {
      styles = []
    }
    for (var i = 0; i < mayRemove.length; i++) {
      var domStyle = mayRemove[i]
      if (domStyle.refs === 0) {
        for (var j = 0; j < domStyle.parts.length; j++) {
          domStyle.parts[j]()
        }
        delete stylesInDom[domStyle.id]
      }
    }
  }
}

function addStylesToDom (styles /* Array<StyleObject> */) {
  for (var i = 0; i < styles.length; i++) {
    var item = styles[i]
    var domStyle = stylesInDom[item.id]
    if (domStyle) {
      domStyle.refs++
      for (var j = 0; j < domStyle.parts.length; j++) {
        domStyle.parts[j](item.parts[j])
      }
      for (; j < item.parts.length; j++) {
        domStyle.parts.push(addStyle(item.parts[j]))
      }
      if (domStyle.parts.length > item.parts.length) {
        domStyle.parts.length = item.parts.length
      }
    } else {
      var parts = []
      for (var j = 0; j < item.parts.length; j++) {
        parts.push(addStyle(item.parts[j]))
      }
      stylesInDom[item.id] = { id: item.id, refs: 1, parts: parts }
    }
  }
}

function createStyleElement () {
  var styleElement = document.createElement('style')
  styleElement.type = 'text/css'
  head.appendChild(styleElement)
  return styleElement
}

function addStyle (obj /* StyleObjectPart */) {
  var update, remove
  var styleElement = document.querySelector('style[' + ssrIdKey + '~="' + obj.id + '"]')

  if (styleElement) {
    if (isProduction) {
      // has SSR styles and in production mode.
      // simply do nothing.
      return noop
    } else {
      // has SSR styles but in dev mode.
      // for some reason Chrome can't handle source map in server-rendered
      // style tags - source maps in <style> only works if the style tag is
      // created and inserted dynamically. So we remove the server rendered
      // styles and inject new ones.
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  if (isOldIE) {
    // use singleton mode for IE9.
    var styleIndex = singletonCounter++
    styleElement = singletonElement || (singletonElement = createStyleElement())
    update = applyToSingletonTag.bind(null, styleElement, styleIndex, false)
    remove = applyToSingletonTag.bind(null, styleElement, styleIndex, true)
  } else {
    // use multi-style-tag mode in all other cases
    styleElement = createStyleElement()
    update = applyToTag.bind(null, styleElement)
    remove = function () {
      styleElement.parentNode.removeChild(styleElement)
    }
  }

  update(obj)

  return function updateStyle (newObj /* StyleObjectPart */) {
    if (newObj) {
      if (newObj.css === obj.css &&
          newObj.media === obj.media &&
          newObj.sourceMap === obj.sourceMap) {
        return
      }
      update(obj = newObj)
    } else {
      remove()
    }
  }
}

var replaceText = (function () {
  var textStore = []

  return function (index, replacement) {
    textStore[index] = replacement
    return textStore.filter(Boolean).join('\n')
  }
})()

function applyToSingletonTag (styleElement, index, remove, obj) {
  var css = remove ? '' : obj.css

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = replaceText(index, css)
  } else {
    var cssNode = document.createTextNode(css)
    var childNodes = styleElement.childNodes
    if (childNodes[index]) styleElement.removeChild(childNodes[index])
    if (childNodes.length) {
      styleElement.insertBefore(cssNode, childNodes[index])
    } else {
      styleElement.appendChild(cssNode)
    }
  }
}

function applyToTag (styleElement, obj) {
  var css = obj.css
  var media = obj.media
  var sourceMap = obj.sourceMap

  if (media) {
    styleElement.setAttribute('media', media)
  }
  if (options.ssrId) {
    styleElement.setAttribute(ssrIdKey, obj.id)
  }

  if (sourceMap) {
    // https://developer.chrome.com/devtools/docs/javascript-debugging
    // this makes source maps inside style tags work properly in Chrome
    css += '\n/*# sourceURL=' + sourceMap.sources[0] + ' */'
    // http://stackoverflow.com/a/26603875
    css += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + ' */'
  }

  if (styleElement.styleSheet) {
    styleElement.styleSheet.cssText = css
  } else {
    while (styleElement.firstChild) {
      styleElement.removeChild(styleElement.firstChild)
    }
    styleElement.appendChild(document.createTextNode(css))
  }
}


/***/ }),

/***/ 55:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["Headers"] = Headers;
/* harmony export (immutable) */ __webpack_exports__["Request"] = Request;
/* harmony export (immutable) */ __webpack_exports__["Response"] = Response;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOMException", function() { return DOMException; });
/* harmony export (immutable) */ __webpack_exports__["fetch"] = fetch;
var support = {
  searchParams: 'URLSearchParams' in self,
  iterable: 'Symbol' in self && 'iterator' in Symbol,
  blob:
    'FileReader' in self &&
    'Blob' in self &&
    (function() {
      try {
        new Blob()
        return true
      } catch (e) {
        return false
      }
    })(),
  formData: 'FormData' in self,
  arrayBuffer: 'ArrayBuffer' in self
}

function isDataView(obj) {
  return obj && DataView.prototype.isPrototypeOf(obj)
}

if (support.arrayBuffer) {
  var viewClasses = [
    '[object Int8Array]',
    '[object Uint8Array]',
    '[object Uint8ClampedArray]',
    '[object Int16Array]',
    '[object Uint16Array]',
    '[object Int32Array]',
    '[object Uint32Array]',
    '[object Float32Array]',
    '[object Float64Array]'
  ]

  var isArrayBufferView =
    ArrayBuffer.isView ||
    function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
}

function normalizeName(name) {
  if (typeof name !== 'string') {
    name = String(name)
  }
  if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
    throw new TypeError('Invalid character in header field name')
  }
  return name.toLowerCase()
}

function normalizeValue(value) {
  if (typeof value !== 'string') {
    value = String(value)
  }
  return value
}

// Build a destructive iterator for the value list
function iteratorFor(items) {
  var iterator = {
    next: function() {
      var value = items.shift()
      return {done: value === undefined, value: value}
    }
  }

  if (support.iterable) {
    iterator[Symbol.iterator] = function() {
      return iterator
    }
  }

  return iterator
}

function Headers(headers) {
  this.map = {}

  if (headers instanceof Headers) {
    headers.forEach(function(value, name) {
      this.append(name, value)
    }, this)
  } else if (Array.isArray(headers)) {
    headers.forEach(function(header) {
      this.append(header[0], header[1])
    }, this)
  } else if (headers) {
    Object.getOwnPropertyNames(headers).forEach(function(name) {
      this.append(name, headers[name])
    }, this)
  }
}

Headers.prototype.append = function(name, value) {
  name = normalizeName(name)
  value = normalizeValue(value)
  var oldValue = this.map[name]
  this.map[name] = oldValue ? oldValue + ', ' + value : value
}

Headers.prototype['delete'] = function(name) {
  delete this.map[normalizeName(name)]
}

Headers.prototype.get = function(name) {
  name = normalizeName(name)
  return this.has(name) ? this.map[name] : null
}

Headers.prototype.has = function(name) {
  return this.map.hasOwnProperty(normalizeName(name))
}

Headers.prototype.set = function(name, value) {
  this.map[normalizeName(name)] = normalizeValue(value)
}

Headers.prototype.forEach = function(callback, thisArg) {
  for (var name in this.map) {
    if (this.map.hasOwnProperty(name)) {
      callback.call(thisArg, this.map[name], name, this)
    }
  }
}

Headers.prototype.keys = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push(name)
  })
  return iteratorFor(items)
}

Headers.prototype.values = function() {
  var items = []
  this.forEach(function(value) {
    items.push(value)
  })
  return iteratorFor(items)
}

Headers.prototype.entries = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push([name, value])
  })
  return iteratorFor(items)
}

if (support.iterable) {
  Headers.prototype[Symbol.iterator] = Headers.prototype.entries
}

function consumed(body) {
  if (body.bodyUsed) {
    return Promise.reject(new TypeError('Already read'))
  }
  body.bodyUsed = true
}

function fileReaderReady(reader) {
  return new Promise(function(resolve, reject) {
    reader.onload = function() {
      resolve(reader.result)
    }
    reader.onerror = function() {
      reject(reader.error)
    }
  })
}

function readBlobAsArrayBuffer(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsArrayBuffer(blob)
  return promise
}

function readBlobAsText(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsText(blob)
  return promise
}

function readArrayBufferAsText(buf) {
  var view = new Uint8Array(buf)
  var chars = new Array(view.length)

  for (var i = 0; i < view.length; i++) {
    chars[i] = String.fromCharCode(view[i])
  }
  return chars.join('')
}

function bufferClone(buf) {
  if (buf.slice) {
    return buf.slice(0)
  } else {
    var view = new Uint8Array(buf.byteLength)
    view.set(new Uint8Array(buf))
    return view.buffer
  }
}

function Body() {
  this.bodyUsed = false

  this._initBody = function(body) {
    this._bodyInit = body
    if (!body) {
      this._bodyText = ''
    } else if (typeof body === 'string') {
      this._bodyText = body
    } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
      this._bodyBlob = body
    } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
      this._bodyFormData = body
    } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
      this._bodyText = body.toString()
    } else if (support.arrayBuffer && support.blob && isDataView(body)) {
      this._bodyArrayBuffer = bufferClone(body.buffer)
      // IE 10-11 can't handle a DataView body.
      this._bodyInit = new Blob([this._bodyArrayBuffer])
    } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
      this._bodyArrayBuffer = bufferClone(body)
    } else {
      this._bodyText = body = Object.prototype.toString.call(body)
    }

    if (!this.headers.get('content-type')) {
      if (typeof body === 'string') {
        this.headers.set('content-type', 'text/plain;charset=UTF-8')
      } else if (this._bodyBlob && this._bodyBlob.type) {
        this.headers.set('content-type', this._bodyBlob.type)
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
      }
    }
  }

  if (support.blob) {
    this.blob = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return Promise.resolve(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(new Blob([this._bodyArrayBuffer]))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as blob')
      } else {
        return Promise.resolve(new Blob([this._bodyText]))
      }
    }

    this.arrayBuffer = function() {
      if (this._bodyArrayBuffer) {
        return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
      } else {
        return this.blob().then(readBlobAsArrayBuffer)
      }
    }
  }

  this.text = function() {
    var rejected = consumed(this)
    if (rejected) {
      return rejected
    }

    if (this._bodyBlob) {
      return readBlobAsText(this._bodyBlob)
    } else if (this._bodyArrayBuffer) {
      return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
    } else if (this._bodyFormData) {
      throw new Error('could not read FormData body as text')
    } else {
      return Promise.resolve(this._bodyText)
    }
  }

  if (support.formData) {
    this.formData = function() {
      return this.text().then(decode)
    }
  }

  this.json = function() {
    return this.text().then(JSON.parse)
  }

  return this
}

// HTTP methods whose capitalization should be normalized
var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

function normalizeMethod(method) {
  var upcased = method.toUpperCase()
  return methods.indexOf(upcased) > -1 ? upcased : method
}

function Request(input, options) {
  options = options || {}
  var body = options.body

  if (input instanceof Request) {
    if (input.bodyUsed) {
      throw new TypeError('Already read')
    }
    this.url = input.url
    this.credentials = input.credentials
    if (!options.headers) {
      this.headers = new Headers(input.headers)
    }
    this.method = input.method
    this.mode = input.mode
    this.signal = input.signal
    if (!body && input._bodyInit != null) {
      body = input._bodyInit
      input.bodyUsed = true
    }
  } else {
    this.url = String(input)
  }

  this.credentials = options.credentials || this.credentials || 'same-origin'
  if (options.headers || !this.headers) {
    this.headers = new Headers(options.headers)
  }
  this.method = normalizeMethod(options.method || this.method || 'GET')
  this.mode = options.mode || this.mode || null
  this.signal = options.signal || this.signal
  this.referrer = null

  if ((this.method === 'GET' || this.method === 'HEAD') && body) {
    throw new TypeError('Body not allowed for GET or HEAD requests')
  }
  this._initBody(body)
}

Request.prototype.clone = function() {
  return new Request(this, {body: this._bodyInit})
}

function decode(body) {
  var form = new FormData()
  body
    .trim()
    .split('&')
    .forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
  return form
}

function parseHeaders(rawHeaders) {
  var headers = new Headers()
  // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
  // https://tools.ietf.org/html/rfc7230#section-3.2
  var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
  preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
    var parts = line.split(':')
    var key = parts.shift().trim()
    if (key) {
      var value = parts.join(':').trim()
      headers.append(key, value)
    }
  })
  return headers
}

Body.call(Request.prototype)

function Response(bodyInit, options) {
  if (!options) {
    options = {}
  }

  this.type = 'default'
  this.status = options.status === undefined ? 200 : options.status
  this.ok = this.status >= 200 && this.status < 300
  this.statusText = 'statusText' in options ? options.statusText : 'OK'
  this.headers = new Headers(options.headers)
  this.url = options.url || ''
  this._initBody(bodyInit)
}

Body.call(Response.prototype)

Response.prototype.clone = function() {
  return new Response(this._bodyInit, {
    status: this.status,
    statusText: this.statusText,
    headers: new Headers(this.headers),
    url: this.url
  })
}

Response.error = function() {
  var response = new Response(null, {status: 0, statusText: ''})
  response.type = 'error'
  return response
}

var redirectStatuses = [301, 302, 303, 307, 308]

Response.redirect = function(url, status) {
  if (redirectStatuses.indexOf(status) === -1) {
    throw new RangeError('Invalid status code')
  }

  return new Response(null, {status: status, headers: {location: url}})
}

var DOMException = self.DOMException
try {
  new DOMException()
} catch (err) {
  DOMException = function(message, name) {
    this.message = message
    this.name = name
    var error = Error(message)
    this.stack = error.stack
  }
  DOMException.prototype = Object.create(Error.prototype)
  DOMException.prototype.constructor = DOMException
}

function fetch(input, init) {
  return new Promise(function(resolve, reject) {
    var request = new Request(input, init)

    if (request.signal && request.signal.aborted) {
      return reject(new DOMException('Aborted', 'AbortError'))
    }

    var xhr = new XMLHttpRequest()

    function abortXhr() {
      xhr.abort()
    }

    xhr.onload = function() {
      var options = {
        status: xhr.status,
        statusText: xhr.statusText,
        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
      }
      options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
      var body = 'response' in xhr ? xhr.response : xhr.responseText
      resolve(new Response(body, options))
    }

    xhr.onerror = function() {
      reject(new TypeError('Network request failed'))
    }

    xhr.ontimeout = function() {
      reject(new TypeError('Network request failed'))
    }

    xhr.onabort = function() {
      reject(new DOMException('Aborted', 'AbortError'))
    }

    xhr.open(request.method, request.url, true)

    if (request.credentials === 'include') {
      xhr.withCredentials = true
    } else if (request.credentials === 'omit') {
      xhr.withCredentials = false
    }

    if ('responseType' in xhr && support.blob) {
      xhr.responseType = 'blob'
    }

    request.headers.forEach(function(value, name) {
      xhr.setRequestHeader(name, value)
    })

    if (request.signal) {
      request.signal.addEventListener('abort', abortXhr)

      xhr.onreadystatechange = function() {
        // DONE (success or failure)
        if (xhr.readyState === 4) {
          request.signal.removeEventListener('abort', abortXhr)
        }
      }
    }

    xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
  })
}

fetch.polyfill = true

if (!self.fetch) {
  self.fetch = fetch
  self.Headers = Headers
  self.Request = Request
  self.Response = Response
}


/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _mockCategories = __webpack_require__(77);

var _mockCategories2 = _interopRequireDefault(_mockCategories);

var _mockSubjects = __webpack_require__(78);

var _mockSubjects2 = _interopRequireDefault(_mockSubjects);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DEFAULT_DIR_PATH = dn.$store.getters['path/$join']('resources', 'data');
var DEFAULT_FILE_NAME = 'mock-subjects.json';
var SSInfo = dn.$store.getters['config/ssinfo'];

var MockSubject = function () {
  _createClass(MockSubject, [{
    key: 'filePath',
    get: function get() {
      return this.dir + '/' + this.fileName;
    }

    /**
     * constructor
     */

  }], [{
    key: 'findCategories',


    /**
     * カテゴリーを検索
     */
    value: function findCategories() {
      var _this = this;

      var ids = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var tree = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      ids = typeof ids === 'string' ? [ids] : ids;
      if (ids === null) {
        return this.CATEGORIES.map(function (category) {
          return _this.getCategory(category.id, tree);
        });
      } else {
        return ids.map(function (id) {
          return _this.getCategory(id, tree);
        });
      }
    }

    /**
     * カテゴリーを取得
     */

  }, {
    key: 'getCategory',
    value: function getCategory(id) {
      var tree = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var category = this.CATEGORIES.find(function (category) {
        return category.id === id;
      });
      if (tree) {
        category.subjects = this.findSubjects({ categoryId: id });
      }
      return category;
    }

    /**
     * 科目を検索
     */

  }, {
    key: 'findSubjects',
    value: function findSubjects() {
      var condition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (condition === null) return this.SUBJECTS;

      condition = typeof condition === 'string' ? { id: condition } : condition;

      var subjects = [];
      this.SUBJECTS.forEach(function (subject) {
        for (var key in condition) {
          if (subject[key] !== condition[key]) continue;
          subjects.push(subject);
        }
      });

      return subjects;
    }

    /**
     * 定義ファイルを読み込む
     */

  }, {
    key: 'load',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(url) {
        var conf, res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // const res = await dn.$http.get(url);
                conf = dn.$store.getters['config/ssinfo'];
                res = {};

                if (!conf.url) {
                  _context.next = 8;
                  break;
                }

                _context.next = 5;
                return dn.$http.post(conf.url, {
                  dataType: 'json',
                  contentType: 'application/json; charset=utf-8',
                  data: JSON.stringify({ gakunen: conf.gakunen, kai: conf.kai, nendo: conf.nendo })
                });

              case 5:
                res = _context.sent;
                _context.next = 11;
                break;

              case 8:
                _context.next = 10;
                return dn.$http.get(url);

              case 10:
                res = _context.sent;

              case 11:
                return _context.abrupt('return', this.parseJson(res.data));

              case 12:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function load(_x5) {
        return _ref.apply(this, arguments);
      }

      return load;
    }()

    /**
     * 定義ファイルをパースする
     */

  }, {
    key: 'parseJson',
    value: function parseJson(json) {
      var subjects = [];
      var errors = [];

      json.kjSSList.forEach(function (row) {
        var id = row.kamokuCd;

        // @memo: 科目コードの末尾が「00」になっているものは教科合計なのでスキップ
        // https://jcomintra.backlog.jp/view/BENE_IMJ_CENTER_TEST_2018-137#comment-1178592421
        if (/00$/.test(id)) return;

        var subject = _mockSubjects2.default.find(function (subject) {
          return subject.id === id;
        });
        if (!subject) {
          errors.push(id);
          return;
        }

        subjects.push({
          id: row.kamokuCd,
          avg: parseInt(row.avg, 10) / 10,
          sd: parseInt(row.sd, 10) / 10,
          max: subject.maxScore
        });
      });

      if (errors.length) {
        var message = '\u6A21\u8A66\u79D1\u76EE\u8A2D\u5B9A\u30D5\u30A1\u30A4\u30EB\u306B\u8A18\u8F09\u306E\u79D1\u76EE\u30B3\u30FC\u30C9\u300C' + errors.join(',') + '\u300D\u306F\u5B9A\u7FA9\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002';
        console.error(message);
        alert(message);
      }

      return subjects;
    }
  }, {
    key: 'CATEGORIES',
    get: function get() {
      return JSON.parse(JSON.stringify(_mockCategories2.default));
    }
  }, {
    key: 'SUBJECTS',
    get: function get() {
      return JSON.parse(JSON.stringify(_mockSubjects2.default));
    }
  }]);

  function MockSubject() {
    var year = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : dn.$store.getters['config/year'];
    var opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, MockSubject);

    this.year = year;
    this.dir = opt.dir || DEFAULT_DIR_PATH;
    this.fileName = opt.fileName || DEFAULT_FILE_NAME;
    this.subjects = null;
    this.histories = {};
  }

  /**
   * 定義ファイルを読み込んでメンバに保持する
   */


  _createClass(MockSubject, [{
    key: 'load',
    value: function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.constructor.load(this.filePath);

              case 2:
                this.subjects = _context2.sent;

                this.restoreHistories();
                return _context2.abrupt('return', this.subjects);

              case 5:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function load() {
        return _ref2.apply(this, arguments);
      }

      return load;
    }()
  }, {
    key: 'restoreHistories',
    value: function restoreHistories() {
      var _this2 = this;

      this.histories = {};
      this.subjects.forEach(function (subject) {
        var score = dn.$ls.get('bible-mock-input-' + subject.id, null);
        _this2.histories[subject.id] = {
          score: score,
          deviation: _this2.getDeviationByScoreAndSubjectId(score, subject.id)
        };
      });
    }

    /**
     * 定義ファイルをパースする
     */

  }, {
    key: 'parseJson',
    value: function parseJson(json) {
      return this.constructor.parseJson(json);
    }

    /**
     * 科目を取得する
     */

  }, {
    key: 'getSubjectById',
    value: function getSubjectById(id) {
      return this.subjects.find(function (subject) {
        return subject.id === id;
      });
    }

    /**
     * 偏差値を算出する
     * ※定義ファイルがロード済みである事
     */

  }, {
    key: 'getDeviationByScoreAndSubjectId',
    value: function getDeviationByScoreAndSubjectId(score, id) {
      if (score === null) return null;

      var define = this.getSubjectById(id);

      var dev = Math.floor(((score * 10 - define.avg * 10) * 1000 / (define.sd * 10) + 5005) / 10);

      if (dev < 0) {
        dev = 0;
      } else if (dev <= 1990) {
        dev /= 10;
      } else {
        dev = 199;
      }

      return dev.toFixed(1);
    }

    /**
     * 偏差値から得点を算出する
     * ※定義ファイルがロード済みである事
     */

  }, {
    key: 'getScoreByDeviationAndSubjectId',
    value: function getScoreByDeviationAndSubjectId(dev, id) {
      if (dev === null) return null;

      var define = this.getSubjectById(id);
      var maxScore = define.max;

      var score = Math.floor(((dev * 10 - 500) * define.sd * 10 + define.avg * 10 * 100 + 500) / 1000);
      if (score < 0) {
        score = 0;
      } else if (score > maxScore) {
        score = maxScore;
      }
      return score;
    }
  }]);

  return MockSubject;
}();

exports.default = MockSubject;

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{ id: '1', name: '国語' }, { id: '2', name: '数学' }, { id: '3', name: '英語' }, { id: '4', name: '地歴公民' }, { id: '5', name: '理科' }];

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [

// 国語
{ id: '101', categoryId: '1', children: ['110', '130'], maxScore: 200, name: '国・現古漢' }, { id: '102', categoryId: '1', children: ['110', '130'], maxScore: 200, name: '国・現古' }, { id: '103', categoryId: '1', children: ['110'], maxScore: 200, name: '国・現のみ' }, { id: '110', categoryId: '1', maxScore: 100, name: '現代文' }, { id: '130', categoryId: '1', maxScore: 200, name: '現古' },

// 数学
{ id: '203', categoryId: '2', maxScore: 200, name: '数学X' }, { id: '202', categoryId: '2', maxScore: 200, name: '数学Y' }, { id: '201', categoryId: '2', maxScore: 200, name: '数学Z' },

// 英語
{ id: '301', categoryId: '3', maxScore: 200, name: '英語' },

// 地歴公民
{ id: '412', categoryId: '4', maxScore: 100, name: '世界史Ｂ' }, { id: '422', categoryId: '4', maxScore: 100, name: '日本史Ｂ' }, { id: '432', categoryId: '4', maxScore: 100, name: '地理Ｂ' }, { id: '453', categoryId: '4', maxScore: 100, name: '現代社会' }, { id: '451', categoryId: '4', maxScore: 100, name: '倫理' }, { id: '452', categoryId: '4', maxScore: 100, name: '政治経済' }, { id: '454', categoryId: '4', maxScore: 100, name: '倫・政' },

// 理科
{ id: '512', categoryId: '5', maxScore: 50, name: '物理基礎' }, { id: '522', categoryId: '5', maxScore: 50, name: '化学基礎' }, { id: '532', categoryId: '5', maxScore: 50, name: '生物基礎' }, { id: '542', categoryId: '5', maxScore: 50, name: '地学基礎' }, { id: '513', categoryId: '5', maxScore: 100, name: '物理' }, { id: '523', categoryId: '5', maxScore: 100, name: '化学' }, { id: '533', categoryId: '5', maxScore: 100, name: '生物' }, { id: '543', categoryId: '5', maxScore: 100, name: '地学' }];

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

/**
 * Translates the list format produced by css-loader into something
 * easier to manipulate.
 */
module.exports = function listToStyles (parentId, list) {
  var styles = []
  var newStyles = {}
  for (var i = 0; i < list.length; i++) {
    var item = list[i]
    var id = item[0]
    var css = item[1]
    var media = item[2]
    var sourceMap = item[3]
    var part = {
      id: parentId + ':' + i,
      css: css,
      media: media,
      sourceMap: sourceMap
    }
    if (!newStyles[id]) {
      styles.push(newStyles[id] = { id: id, parts: [part] })
    } else {
      newStyles[id].parts.push(part)
    }
  }
  return styles
}


/***/ }),

/***/ 896:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _App = __webpack_require__(897);

var _App2 = _interopRequireDefault(_App);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

Vue.component(_App2.default.name, _App2.default);

/***/ }),

/***/ 897:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(898)
  __webpack_require__(900)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(902),
  /* template */
  __webpack_require__(923),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-6bc902d8",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 898:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(899);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("da0d91aa", content, true, {});

/***/ }),

/***/ 899:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(true);
// imports


// module
exports.push([module.i, ".pg-top-links>li{margin-top:8px}@media (min-width:710px){.pg-top-links{margin-left:-20px}.pg-top-links>li{display:inline-block;margin-left:20px}}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/js/jikosaiten/index/App.vue"],"names":[],"mappings":"AACA,iBAAiB,cAAc,CAC9B,AACD,yBACA,cAAc,iBAAiB,CAC9B,AACD,iBAAiB,qBAAqB,gBAAgB,CACrD,CACA","file":"App.vue","sourcesContent":["\n.pg-top-links>li{margin-top:8px\n}\n@media (min-width:710px){\n.pg-top-links{margin-left:-20px\n}\n.pg-top-links>li{display:inline-block;margin-left:20px\n}\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 900:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(901);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("6c3a9ddb", content, true, {});

/***/ }),

/***/ 901:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(true);
// imports


// module
exports.push([module.i, ".my__categories[data-v-6bc902d8],.my__category[data-v-6bc902d8]:not(:first-child),.my__option[data-v-6bc902d8]{margin-top:30px}.my__total[data-v-6bc902d8]{margin-top:20px;text-align:center}.my__total__btn-calc .dn-icon[data-v-6bc902d8]{margin-top:-.15em}.my__total__separator[data-v-6bc902d8]{display:block;width:200px;height:50px;border-top:50px solid #beebfa;border-left:100px solid transparent;border-right:100px solid transparent;border-bottom:0;margin:20px auto}.my__total__loading[data-v-6bc902d8]{display:inline-block;vertical-align:middle}.my__total__result[data-v-6bc902d8]{border:1px solid #adc4cc;padding:20px;text-align:center}.my__total__result__values[data-v-6bc902d8]{display:inline-block}.my__total__result__value[data-v-6bc902d8]{color:#0aa0d7;margin:0 .25em}.my__total__area-retry[data-v-6bc902d8]{padding-top:20px;text-align:center;-webkit-transition:height .4s cubic-bezier(.4,0,.2,1);transition:height .4s cubic-bezier(.4,0,.2,1)}.my__btn-clear[data-v-6bc902d8]{margin-top:30px;font-weight:700}.my__btn-to-checker[data-v-6bc902d8]{margin-top:20px}.manabi-jikosaiten .my__categories[data-v-6bc902d8]{margin-top:10px}.manabi-jikosaiten .my-section__head-group .dn-heading-2[data-v-6bc902d8]{text-align:left}.manabi-jikosaiten .dn-tabs-top[data-v-6bc902d8]{margin-bottom:25px;border-top:1px solid #adc4cc}.manabi-jikosaiten .dn-tabs-top a[data-v-6bc902d8]{margin-bottom:25px}.manabi-jikosaiten .dn-tabs__next[data-v-6bc902d8]{border-top:1px solid #adc4cc}@media (max-width:709px){.my__category[data-v-6bc902d8]:not(:first-child){margin-top:20px}.my__total__btn-calc[data-v-6bc902d8]{width:100%}.my__total__separator[data-v-6bc902d8]{width:100px;height:25px;border-top:25px solid #beebfa;border-left:50px solid transparent;border-right:50px solid transparent}.my__total__result__value[data-v-6bc902d8]{font-size:16px}.my__total__btn-retry[data-v-6bc902d8]{width:220px}.manabi-jikosaiten .dn-tabs-top a[data-v-6bc902d8],.manabi-jikosaiten .tar .dn-btn[data-v-6bc902d8],.my__btn-under[data-v-6bc902d8]{width:100%}}@media (min-width:710px){.my__total__btn-calc[data-v-6bc902d8]{min-width:300px}.my__total__result__value[data-v-6bc902d8]{font-size:24px}.my__total__btn-retry[data-v-6bc902d8]{min-width:220px}.my__btn-under[data-v-6bc902d8]{min-width:360px}.manabi-jikosaiten .my-section__head-group[data-v-6bc902d8]{margin-left:156px}}@media (max-width:400px){.my__btn-under[data-v-6bc902d8]{font-size:11px;padding-left:0;padding-right:0}}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/js/jikosaiten/index/App.vue"],"names":[],"mappings":"AACA,+GAA+G,eAAe,CAC7H,AACD,4BAA4B,gBAAgB,iBAAiB,CAC5D,AACD,+CAA+C,iBAAiB,CAC/D,AACD,uCAAuC,cAAc,YAAY,YAAY,8BAA8B,oCAAoC,qCAAqC,gBAAgB,gBAAgB,CACnN,AACD,qCAAqC,qBAAqB,qBAAqB,CAC9E,AACD,oCAAoC,yBAAyB,aAAa,iBAAiB,CAC1F,AACD,4CAA4C,oBAAoB,CAC/D,AACD,2CAA2C,cAAc,cAAc,CACtE,AACD,wCAAwC,iBAAiB,kBAAkB,sDAAsD,6CAA6C,CAC7K,AACD,gCAAgC,gBAAgB,eAAe,CAC9D,AACD,qCAAqC,eAAe,CACnD,AACD,oDAAoD,eAAe,CAClE,AACD,0EAA0E,eAAe,CACxF,AACD,iDAAiD,mBAAmB,4BAA4B,CAC/F,AACD,mDAAmD,kBAAkB,CACpE,AACD,mDAAmD,4BAA4B,CAC9E,AACD,yBACA,iDAAiD,eAAe,CAC/D,AACD,sCAAsC,UAAU,CAC/C,AACD,uCAAuC,YAAY,YAAY,8BAA8B,mCAAmC,mCAAmC,CAClK,AACD,2CAA2C,cAAc,CACxD,AACD,uCAAuC,WAAW,CACjD,AACD,oIAAoI,UAAU,CAC7I,CACA,AACD,yBACA,sCAAsC,eAAe,CACpD,AACD,2CAA2C,cAAc,CACxD,AACD,uCAAuC,eAAe,CACrD,AACD,gCAAgC,eAAe,CAC9C,AACD,4DAA4D,iBAAiB,CAC5E,CACA,AACD,yBACA,gCAAgC,eAAe,eAAe,eAAe,CAC5E,CACA","file":"App.vue","sourcesContent":["\n.my__categories[data-v-6bc902d8],.my__category[data-v-6bc902d8]:not(:first-child),.my__option[data-v-6bc902d8]{margin-top:30px\n}\n.my__total[data-v-6bc902d8]{margin-top:20px;text-align:center\n}\n.my__total__btn-calc .dn-icon[data-v-6bc902d8]{margin-top:-.15em\n}\n.my__total__separator[data-v-6bc902d8]{display:block;width:200px;height:50px;border-top:50px solid #beebfa;border-left:100px solid transparent;border-right:100px solid transparent;border-bottom:0;margin:20px auto\n}\n.my__total__loading[data-v-6bc902d8]{display:inline-block;vertical-align:middle\n}\n.my__total__result[data-v-6bc902d8]{border:1px solid #adc4cc;padding:20px;text-align:center\n}\n.my__total__result__values[data-v-6bc902d8]{display:inline-block\n}\n.my__total__result__value[data-v-6bc902d8]{color:#0aa0d7;margin:0 .25em\n}\n.my__total__area-retry[data-v-6bc902d8]{padding-top:20px;text-align:center;-webkit-transition:height .4s cubic-bezier(.4,0,.2,1);transition:height .4s cubic-bezier(.4,0,.2,1)\n}\n.my__btn-clear[data-v-6bc902d8]{margin-top:30px;font-weight:700\n}\n.my__btn-to-checker[data-v-6bc902d8]{margin-top:20px\n}\n.manabi-jikosaiten .my__categories[data-v-6bc902d8]{margin-top:10px\n}\n.manabi-jikosaiten .my-section__head-group .dn-heading-2[data-v-6bc902d8]{text-align:left\n}\n.manabi-jikosaiten .dn-tabs-top[data-v-6bc902d8]{margin-bottom:25px;border-top:1px solid #adc4cc\n}\n.manabi-jikosaiten .dn-tabs-top a[data-v-6bc902d8]{margin-bottom:25px\n}\n.manabi-jikosaiten .dn-tabs__next[data-v-6bc902d8]{border-top:1px solid #adc4cc\n}\n@media (max-width:709px){\n.my__category[data-v-6bc902d8]:not(:first-child){margin-top:20px\n}\n.my__total__btn-calc[data-v-6bc902d8]{width:100%\n}\n.my__total__separator[data-v-6bc902d8]{width:100px;height:25px;border-top:25px solid #beebfa;border-left:50px solid transparent;border-right:50px solid transparent\n}\n.my__total__result__value[data-v-6bc902d8]{font-size:16px\n}\n.my__total__btn-retry[data-v-6bc902d8]{width:220px\n}\n.manabi-jikosaiten .dn-tabs-top a[data-v-6bc902d8],.manabi-jikosaiten .tar .dn-btn[data-v-6bc902d8],.my__btn-under[data-v-6bc902d8]{width:100%\n}\n}\n@media (min-width:710px){\n.my__total__btn-calc[data-v-6bc902d8]{min-width:300px\n}\n.my__total__result__value[data-v-6bc902d8]{font-size:24px\n}\n.my__total__btn-retry[data-v-6bc902d8]{min-width:220px\n}\n.my__btn-under[data-v-6bc902d8]{min-width:360px\n}\n.manabi-jikosaiten .my-section__head-group[data-v-6bc902d8]{margin-left:156px\n}\n}\n@media (max-width:400px){\n.my__btn-under[data-v-6bc902d8]{font-size:11px;padding-left:0;padding-right:0\n}\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 902:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Category = __webpack_require__(903);

var _Category2 = _interopRequireDefault(_Category);

var _Option = __webpack_require__(918);

var _Option2 = _interopRequireDefault(_Option);

var _judgementInfo = __webpack_require__(151);

var _judgementInfo2 = _interopRequireDefault(_judgementInfo);

__webpack_require__(55);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var DEFAULT_CONFIG = {
  apiPost: true,
  apiUrl: 'https://dn.benesse.ne.jp/resultRegistarAPI/',
  debug: false
};

exports.default = {
  name: 'dn-selfcheck-index-app',

  components: {
    MyCategory: _Category2.default,
    MyOption: _Option2.default
  },

  provide: function provide() {
    return {
      resetCaliculateState: this.resetCaliculateState
    };
  },
  data: function data() {
    return {
      mounted: false,
      loadState: 'pending',
      config: null,
      calculateState: 'pending'
    };
  },


  computed: {
    year: function year() {
      return this.$store.getters['config/year'];
    },
    seisekiApiConfig: function seisekiApiConfig() {
      return this.$store.getters['config/seisekiApi'];
    },
    isLoading: function isLoading() {
      return this.loadState === 'loading';
    },
    isLoaded: function isLoaded() {
      return this.loadState === 'loaded';
    },
    mountAndLoaded: function mountAndLoaded() {
      return this.mounted && this.isLoaded;
    },
    isDebug: function isDebug() {
      return this.config.debug;
    },
    apiPost: function apiPost() {
      return this.config.apiPost;
    },
    apiUrl: function apiUrl() {
      return this.$store.getters['config/envIs']('develop') ? '/resultRegistarAPI/' : this.config.apiUrl;
    },
    categories: function categories() {
      return this.isLoaded && this.$store.getters['selfcheck/groupedCategories'];
    },
    fixedSubjects: function fixedSubjects() {
      return this.isLoaded ? this.$store.getters['selfcheck/fixedSubjects'] : [];
    },
    indeterminateSubjects: function indeterminateSubjects() {
      return this.isLoaded ? this.$store.getters['selfcheck/indeterminateSubjects'] : [];
    },
    totalHistory: function totalHistory() {
      return this.isLoaded && this.$store.getters['selfcheck/totalHistory'];
    },
    canCalculate: function canCalculate() {
      return this.fixedSubjects.length > 0 && this.indeterminateSubjects.length === 0;
    },
    isActiveBtnCalculate: function isActiveBtnCalculate() {
      return this.canCalculate && !this.isCalculating && !this.isCalculated;
    },
    isCalculating: function isCalculating() {
      return this.calculateState === 'calculating';
    },
    isCalculated: function isCalculated() {
      return this.calculateState === 'calculated';
    },
    isManabi: function isManabi() {
      return this.$store.getters['config/isManabi'];
    },
    data: function data() {
      return this.$store.getters['selfcheck/groupedCategoryById'](this.id);
    },
    subjects: function subjects() {
      return this.data.subjects;
    },
    firstChoiceSubjects: function firstChoiceSubjects() {
      var _this = this;

      return this.subjects.map(function (subject) {
        var history = _this.$store.getters['selfcheck/subjectHistory'](subject.id);
        return {
          id: subject.id,
          name: subject.name,
          fixed: history.state === 'fixed'
        };
      });
    },
    firstChoice: function firstChoice() {
      return this.$store.getters['selfcheck/groupedCategoryFirstChoice'](this.id);
    }
  },

  watch: {
    mountAndLoaded: function mountAndLoaded(val) {
      if (val) this.tryScrollToSubjectAnchor();
    }
  },

  methods: {
    init: function init() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.loadState = 'loading';
                _context.next = 3;
                return Promise.all([_this2.$store.dispatch('selfcheck/load'), _this2.loadConfig()]);

              case 3:
                _context.next = 5;
                return _this2.setupSelectionMode();

              case 5:

                dn.window.on('show.dn-selfcheck-app', function () {
                  _this2.setupSelectionMode();
                });

                _this2.loadState = 'loaded';

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    setupSelectionMode: function setupSelectionMode() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var selectionMode, subjects, selectionChangePromises, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, subject, _history;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                selectionMode = _this3.$store.getters['config/isManabi'] ? 'direct' : 'selfcheck';
                subjects = _this3.$store.getters['selfcheck/subjects'];
                selectionChangePromises = [];
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context2.prev = 6;

                for (_iterator = subjects[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  subject = _step.value;
                  _history = _this3.$store.getters['selfcheck/subjectHistory'](subject.id);

                  if (selectionMode === 'direct') {
                    selectionChangePromises.push(_this3.$store.dispatch('selfcheck/setSubjectHistory', { id: subject.id, data: { type: 'direct' } }));
                  } else if (selectionMode === 'selfcheck') {
                    if (_history.type !== 'selfcheck' && _history.selfcheckScore === null && _history.directScore === null) {
                      selectionChangePromises.push(_this3.$store.dispatch('selfcheck/setSubjectHistory', { id: subject.id, data: { type: 'selfcheck' } }));
                    }
                  }
                }
                _context2.next = 14;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2['catch'](6);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 14:
                _context2.prev = 14;
                _context2.prev = 15;

                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }

              case 17:
                _context2.prev = 17;

                if (!_didIteratorError) {
                  _context2.next = 20;
                  break;
                }

                throw _iteratorError;

              case 20:
                return _context2.finish(17);

              case 21:
                return _context2.finish(14);

              case 22:
                if (!selectionChangePromises.length) {
                  _context2.next = 25;
                  break;
                }

                _context2.next = 25;
                return Promise.all(selectionChangePromises);

              case 25:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this3, [[6, 10, 14, 22], [15,, 17, 21]]);
      }))();
    },
    loadConfig: function loadConfig() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var url, res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                url = _this4.$store.getters['path/$join']('resources', 'jikosaiten/js/variable.json');
                _context3.next = 3;
                return _this4.$http.get(url);

              case 3:
                res = _context3.sent;


                _this4.config = Object.assign({}, DEFAULT_CONFIG, res.data);

                if (_this4.isDebug || _this4.$store.getters['config/envIs']('develop')) {
                  console.group('自己採点API送信設定');
                  console.log(JSON.parse(JSON.stringify(_this4.config)));
                  console.groupEnd();
                }

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    onClickBtnCalculate: function onClickBtnCalculate() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var optionErrors;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                optionErrors = _this5.$refs.option.errors;

                if (!optionErrors.length) {
                  _context4.next = 4;
                  break;
                }

                dn.$alert(optionErrors.join('\n'));
                return _context4.abrupt('return', false);

              case 4:
                if (!_this5.isDebug) {
                  _context4.next = 10;
                  break;
                }

                _context4.next = 7;
                return dn.$confirm('計算処理を実行します。\n\n' + '送信先URL: ' + _this5.apiUrl + '\n' + '送信フラグ: ' + (_this5.apiPost ? '送信する' : '送信しない') + '\n' + 'ID: ' + _this5.$store.getters['segments/device/uid'] + '\n' + 'デバイス : ' + (_this5.$store.getters['segments/device/type'] === 1 ? 'PC' : 'スマートフォン'));

              case 7:
                if (_context4.sent) {
                  _context4.next = 10;
                  break;
                }

                dn.$alert('キャンセルしました。');
                return _context4.abrupt('return', false);

              case 10:
                return _context4.abrupt('return', _this5.calculateTotalScore());

              case 11:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5);
      }))();
    },
    getInputById: function getInputById(id) {
      var $ref = this.$refs['subjectScoreFields-' + id];
      return $ref ? $ref[0] : null;
    },
    getSendApiParams: function getSendApiParams() {
      return Object.assign(this.getSendOptions(), { p9: this.totalHistory.score }, this.getSendSubjectData());
    },
    getSendOptions: function getSendOptions() {
      var selectedOptions = this.$refs.option.targetValues;
      return {
        p1: this.year,
        p2: this.$store.getters['segments/device/uid'],
        p5: this.$store.getters['segments/device/type'],
        p6: selectedOptions.liberal,
        p7: selectedOptions.pref,
        p8: selectedOptions.questionnaire
      };
    },


    // @see: store.getters.selfcheck/subjectInputsApiParams
    getSendSubjectData: function getSendSubjectData() {
      var data = {};
      var fixedSubjects = this.$store.getters['selfcheck/fixedSubjects'];
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = fixedSubjects[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var subject = _step2.value;

          Object.assign(data, this.$store.getters['selfcheck/subjectInputsApiParams'](subject.id));
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return data;
    },
    sendApiParams: function sendApiParams(params) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var url, res;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                if (_this6.apiPost) {
                  _context5.next = 2;
                  break;
                }

                return _context5.abrupt('return');

              case 2:
                url = _this6.apiUrl;
                _context5.prev = 3;
                _context5.next = 6;
                return _this6.$http.post(url, { data: params });

              case 6:
                res = _context5.sent;

                if (!res.data || res.data !== '<html><head></head><body>OK</body></html>') {
                  console.warn('自己採点APIからのフォーマットが異常ですが、エラー処理をキャンセルします');
                  console.warn(res);
                }
                _context5.next = 14;
                break;

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5['catch'](3);

                console.warn('自己採点APIへの送信でエラーが発生しましたが、エラー処理をキャンセルします');
                console.warn(_context5.t0);

              case 14:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, _this6, [[3, 10]]);
      }))();
    },
    calculateTotalScore: function calculateTotalScore() {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var params;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _this7.calculateState = 'calculating';
                _this7.$scrollTo(_this7.$refs.calculateResult);
                params = _this7.getSendApiParams();
                _context6.next = 5;
                return _this7.sendApiParams(params);

              case 5:
                _this7.calculateState = 'calculated';

              case 6:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, _this7);
      }))();
    },
    onClickBtnClear: function onClickBtnClear() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return dn.$confirm('入力した内容が全て消えますがよろしいですか？');

              case 2:
                if (!_context7.sent) {
                  _context7.next = 4;
                  break;
                }

                _this8.allClear();

              case 4:
                if (_this8.$store.getters['config/isManabi']) {
                  // リセットしてリロード（マナビ採点表示暫定対応）
                  _this8.screenReload();
                }

              case 5:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, _this8);
      }))();
    },


    // 画面遷移時、第1解答科目を選択しているかチェック
    onClickBtnChecker: function onClickBtnChecker(url) {
      var _this9 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var info, firstChoiceErrors;
        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                info = new _judgementInfo2.default();
                _context8.next = 3;
                return info.init();

              case 3:
                _context8.next = 5;
                return info.updateHistories();

              case 5:
                if (!(info.firstChoiceErrors.slice().length > 0)) {
                  _context8.next = 9;
                  break;
                }

                firstChoiceErrors = info.firstChoiceErrors.map(function (error) {
                  return error.name;
                });

                if (confirm(firstChoiceErrors.join("、") + "の第1解答科目が未選択ですがよろしいですか？")) {
                  _context8.next = 9;
                  break;
                }

                return _context8.abrupt('return');

              case 9:
                location.href = url;

              case 10:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, _this9);
      }))();
    },
    onClickBtnReset: function onClickBtnReset() {
      return this.reset();
    },
    resetCaliculateState: function resetCaliculateState() {
      this.calculateState = 'pending';
    },
    reset: function reset() {
      var _this10 = this;

      this.resetCaliculateState();
      this.$nextTick(function () {
        _this10.$scrollTo(document.body);
      });
    },
    allClear: function allClear() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _this11.$store.dispatch('selfcheck/clearAllHistories');
                _this11.reset();

              case 2:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, _this11);
      }))();
    },
    tryScrollToSubjectAnchor: function tryScrollToSubjectAnchor() {
      if (!location.hash) return;

      var id = location.hash.replace(/^#/, '');
      if (!/^\d{3}$/.test(id)) return;

      this.$nextTick(function () {
        setTimeout(function () {
          var el = document.getElementById('a' + id);
          window.scrollTo(0, el.offsetTop);
          window.history && history.replaceState && history.replaceState('', document.title, window.location.pathname + window.location.search);
        }, 100);
      });
    },


    // 成績取得初期設定
    getApiDataInit: function getApiDataInit() {
      // 成績取得前にデータをクリアする
      // this.clearDirectScore();
      this.$store.dispatch('selfcheck/clearAllHistories');
      // 通信
      this.getApiData();
    },
    getApiData: function getApiData() {
      var _this12 = this;

      // 2021年DN回の成績を取得
      window.fetch( /*"../data/examRslt.json"*/
      this.seisekiApiConfig.domain.manabi + "seiseki/services/dnExamRslt",
      // "/manabi/center/resources/data/dnExamRslt.json",
      {
        credentials: "include",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json"
        },
        referrer: this.seisekiApiConfig.domain.dn,
        referrerPolicy: "no-referrer-when-downgrade",
        // 2021年DN回
        body: "{\"examId\":\"" + this.seisekiApiConfig.examId.dn.replace("{GAKUNEN}", "K3") + "\"}",
        method: "POST",
        mode: "cors"
      }).then(function (exm_response) {
        return exm_response.json();
      }).then(function (octoberScore) {

        if (!octoberScore.seiseki) {
          // 通信エラー
          _this12.$refs['dialog-alert_noscore'].show();
          return;
        } else if (!octoberScore.seiseki.seisekiList) {
          // 成績が無い場合
          // (this.$refs[`dialog-alert_noscore`]).show();
          // 高校3年生で成績が取れない場合、既卒で取りに行く
          _this12.getApiDataKisotu();
          return;
        } else {
          // 成績がある場合
          _this12.$refs['dialog-alert_success'].show();
        }

        var subjectScore = $.grep(octoberScore.seiseki.seisekiList, function (score) {
          return score.kmkType === 2;
        });

        if (subjectScore.length < 1) {
          _this12.$refs['dialog-alert_noscore'].show();
          return;
        }
        _this12.$refs.categories.forEach(function (category) {
          category.$refs.subjects.forEach(function (subject) {
            var id = subject.$el.id.replace('subject-', '');
            var target = $.grep(subjectScore, function (score) {
              return score.kmkCrsCd.slice(-3) === id;
            });
            if (target.length > 0) {
              var data = {
                type: "direct",
                directScore: target[0].keiten,
                selected: true,
                selfCheckIsFinished: false
              };
              _this12.$store.dispatch('selfcheck/setSubjectHistory', { id: id, data: data });
            }
            // 現代文・古文・漢文表示対応
            if (id === "106") {
              subject.$children.forEach(function (sub_subject) {
                var id = sub_subject.$el.id.replace('subject-', '');
                var target = $.grep(subjectScore, function (score) {
                  return score.kmkCrsCd.slice(-3) === id;
                });
                if (target.length > 0) {
                  var _data = {
                    type: "direct",
                    directScore: target[0].keiten,
                    selected: true,
                    selfCheckIsFinished: false
                  };
                  _this12.$store.dispatch('selfcheck/setSubjectHistory', { id: id, data: _data });
                }
              });
            }
          });
        });
        _this12.setFirstChoiceFlg(subjectScore);
      }).catch(function (exm_err) {
        _this12.$refs['dialog-alert_scoreerr'].show();
      });
    },

    /** 第一解答科目を設定する */
    setFirstChoiceFlg: function setFirstChoiceFlg(subjectScore) {
      var _this13 = this;

      var NEED_FIRST_CHOICE_MAP = {
        soci: { groupId: '1_2' }, // 地理歴史・公民
        scie: { groupId: '6', uses: ['513', '523', '533', '543'] } // 理科
      };
      var firstchoiceSociFlg = false;
      var firstchoiceScieFlg = false;
      // 地理歴史・公民か理科のみを対象
      var target = $.grep(subjectScore, function (score) {
        return score.kmkCrsCd.slice(1, 2) === '4' || score.kmkCrsCd.slice(1, 2) === '5';
      });
      if (target.length > 0) {
        target.forEach(function (score) {
          var id = score.kmkCrsCd.slice(-3);
          if (id.slice(0, 1) === '4') {
            // 先頭の科目コードを第一解答科目として設定する。
            if (!firstchoiceSociFlg) {
              _this13.$store.dispatch('selfcheck/setGroupedCategoryFirstChoice', { categoryId: NEED_FIRST_CHOICE_MAP["soci"].groupId, subjectId: id });
              firstchoiceSociFlg = true;
            }
          }
          if (id.slice(0, 1) === '5' && NEED_FIRST_CHOICE_MAP["scie"].uses.includes(id)) {
            // 先頭の科目コードを第一解答科目として設定する。
            if (!firstchoiceScieFlg) {
              _this13.$store.dispatch('selfcheck/setGroupedCategoryFirstChoice', { categoryId: NEED_FIRST_CHOICE_MAP["scie"].groupId, subjectId: id });
              firstchoiceScieFlg = true;
            }
          }
        });
      }
    },

    // 成績取得（既卒）
    getApiDataKisotu: function getApiDataKisotu() {
      var _this14 = this;

      // 2021年DN回の成績を取得
      window.fetch( /*"../data/examRslt.json"*/
      this.seisekiApiConfig.domain.manabi + "seiseki/services/dnExamRslt",
      // '/manabi/center/resources/data/dnExamRslt.json',
      {
        credentials: "include",
        headers: {
          "Accept": "application/json",
          "Content-Type": "application/json"
        },
        referrer: this.seisekiApiConfig.domain.dn,
        referrerPolicy: "no-referrer-when-downgrade",
        // 2021年DN回
        body: "{\"examId\":\"" + this.seisekiApiConfig.examId.dn.replace("{GAKUNEN}", "S4") + "\"}",
        method: "POST",
        mode: "cors"
      }).then(function (exm_response) {
        return exm_response.json();
      }).then(function (octoberScore) {

        if (!octoberScore.seiseki) {
          // 通信エラー
          _this14.$refs['dialog-alert_noscore'].show();
          return;
        } else if (!octoberScore.seiseki.seisekiList) {
          // 成績が無い場合
          _this14.$refs['dialog-alert_noscore'].show();
          return;
        } else {
          // 成績がある場合
          _this14.$refs['dialog-alert_success'].show();
        }

        var subjectScore = $.grep(octoberScore.seiseki.seisekiList, function (score) {
          return score.kmkType === 2;
        });

        if (subjectScore.length < 1) {
          _this14.$refs['dialog-alert_noscore'].show();
          return;
        }

        _this14.$refs.categories.forEach(function (category) {
          category.$refs.subjects.forEach(function (subject) {
            var id = subject.$el.id.replace('subject-', '');

            var target = $.grep(subjectScore, function (score) {
              return score.kmkCrsCd.slice(-3) === id;
            });

            if (target.length > 0) {
              var data = {
                type: "direct",
                directScore: target[0].keiten,
                selected: true,
                selfCheckIsFinished: false
              };

              _this14.$store.dispatch('selfcheck/setSubjectHistory', { id: id, data: data });
            }
            // 現代文・古文・漢文表示対応
            if (id === "106") {
              subject.$children.forEach(function (sub_subject) {
                var id = sub_subject.$el.id.replace('subject-', '');
                var target = $.grep(subjectScore, function (score) {
                  return score.kmkCrsCd.slice(-3) === id;
                });
                if (target.length > 0) {
                  var _data2 = {
                    type: "direct",
                    directScore: target[0].keiten,
                    selected: true,
                    selfCheckIsFinished: false
                  };
                  _this14.$store.dispatch('selfcheck/setSubjectHistory', { id: id, data: _data2 });
                }
              });
            }
          });
        });
      }).catch(function (exm_err) {
        _this14.$refs['dialog-alert_scoreerr'].show();
      });
    },


    // 画面リロード
    screenReload: function screenReload() {
      location.reload();
    }
  },

  mounted: function mounted() {
    this.mounted = true;
  },
  created: function created() {
    this.init();
  }
};

/***/ }),

/***/ 903:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(904)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(906),
  /* template */
  __webpack_require__(917),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-0b1ccfce",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 904:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(905);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("6edd683e", content, true, {});

/***/ }),

/***/ 905:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(true);
// imports


// module
exports.push([module.i, ".my__first-subject[data-v-0b1ccfce]{margin-bottom:20px;margin-top:20px}.my__subjects[data-v-0b1ccfce]{border:1px solid #adc4cc}.my__subject[data-v-0b1ccfce]:not(:first-child){border-top:1px solid #adc4cc}.my__judgement-notes[data-v-0b1ccfce]{font-size:90%;margin-bottom:10px}@media (min-width:710px){.my__first-subject[data-v-0b1ccfce]{border:1px solid #adc4cc;padding:19px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-webkit-justify-content:flex-start;-ms-flex-pack:start;justify-content:flex-start}.my__first-subject__select[data-v-0b1ccfce]{min-width:190px}.my__first-subject__guide[data-v-0b1ccfce]{margin-left:20px}}@media (max-width:709px){.my__first-subject[data-v-0b1ccfce]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}.my__first-subject__select[data-v-0b1ccfce]{width:100%;-webkit-box-ordinal-group:3;-webkit-order:2;-ms-flex-order:2;order:2;margin-top:5px}.my__first-subject__guide[data-v-0b1ccfce]{-webkit-box-ordinal-group:2;-webkit-order:1;-ms-flex-order:1;order:1}}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/js/jikosaiten/index/components/Category.vue"],"names":[],"mappings":"AACA,oCAAoC,mBAAmB,eAAe,CACrE,AACD,+BAA+B,wBAAwB,CACtD,AACD,gDAAgD,4BAA4B,CAC3E,AACD,sCAAsC,cAAc,kBAAkB,CACrE,AACD,yBACA,oCAAoC,yBAAyB,aAAa,oBAAoB,qBAAqB,oBAAoB,aAAa,yBAAyB,2BAA2B,sBAAsB,mBAAmB,uBAAuB,mCAAmC,oBAAoB,0BAA0B,CACxV,AACD,4CAA4C,eAAe,CAC1D,AACD,2CAA2C,gBAAgB,CAC1D,CACA,AACD,yBACA,oCAAoC,oBAAoB,qBAAqB,oBAAoB,aAAa,4BAA4B,6BAA6B,8BAA8B,0BAA0B,qBAAqB,CACnP,AACD,4CAA4C,WAAW,4BAA4B,gBAAgB,iBAAiB,QAAQ,cAAc,CACzI,AACD,2CAA2C,4BAA4B,gBAAgB,iBAAiB,OAAO,CAC9G,CACA","file":"Category.vue","sourcesContent":["\n.my__first-subject[data-v-0b1ccfce]{margin-bottom:20px;margin-top:20px\n}\n.my__subjects[data-v-0b1ccfce]{border:1px solid #adc4cc\n}\n.my__subject[data-v-0b1ccfce]:not(:first-child){border-top:1px solid #adc4cc\n}\n.my__judgement-notes[data-v-0b1ccfce]{font-size:90%;margin-bottom:10px\n}\n@media (min-width:710px){\n.my__first-subject[data-v-0b1ccfce]{border:1px solid #adc4cc;padding:19px;display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:start;-webkit-justify-content:flex-start;-ms-flex-pack:start;justify-content:flex-start\n}\n.my__first-subject__select[data-v-0b1ccfce]{min-width:190px\n}\n.my__first-subject__guide[data-v-0b1ccfce]{margin-left:20px\n}\n}\n@media (max-width:709px){\n.my__first-subject[data-v-0b1ccfce]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column\n}\n.my__first-subject__select[data-v-0b1ccfce]{width:100%;-webkit-box-ordinal-group:3;-webkit-order:2;-ms-flex-order:2;order:2;margin-top:5px\n}\n.my__first-subject__guide[data-v-0b1ccfce]{-webkit-box-ordinal-group:2;-webkit-order:1;-ms-flex-order:1;order:1\n}\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 906:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Subject = __webpack_require__(907);

var _Subject2 = _interopRequireDefault(_Subject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  components: {
    MySubject: _Subject2.default
  },

  props: {
    id: {
      type: String,
      required: true
    }
  },

  inject: ['resetCaliculateState'],

  computed: {
    data: function data() {
      return this.$store.getters['selfcheck/groupedCategoryById'](this.id);
    },
    name: function name() {
      return this.data.name;
    },
    subjects: function subjects() {
      return this.data.subjects;
    },
    firstChoiceSelectable: function firstChoiceSelectable() {
      return this.data.firstChoiceSelectable;
    },

    firstChoice: {
      get: function get() {
        return this.$store.getters['selfcheck/groupedCategoryFirstChoice'](this.id);
      },
      set: function set(val) {
        var _this = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return _this.$store.dispatch('selfcheck/setGroupedCategoryFirstChoice', { categoryId: _this.id, subjectId: val });

                case 2:
                  _this.resetCaliculateState && _this.resetCaliculateState();

                case 3:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }))();
      }
    },
    firstChoiceSubjects: function firstChoiceSubjects() {
      var _this2 = this;

      return this.subjects.map(function (subject) {
        var history = _this2.$store.getters['selfcheck/subjectHistory'](subject.id);
        return {
          id: subject.id,
          name: subject.name,
          fixed: history.state === 'fixed'
        };
      });
    }
  },

  methods: {
    onChangeSubjectState: function onChangeSubjectState(subject, state) {
      if (state !== 'fixed' && this.firstChoice === subject.id) {
        this.firstChoice = null;
      }
    }
  }
};

/***/ }),

/***/ 907:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(908)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(910),
  /* template */
  __webpack_require__(916),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2e19bb8c",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 908:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(909);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("270d3e3c", content, true, {});

/***/ }),

/***/ 909:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(true);
// imports


// module
exports.push([module.i, ".my[data-v-2e19bb8c]:not(.my--selected){background:#eff3f5;color:#adc4cc}.my--selected[data-v-2e19bb8c]{background:#fff5aa}.my--fixed[data-v-2e19bb8c]{background:#fff}.my__body[data-v-2e19bb8c],.my__name[data-v-2e19bb8c]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.my__name[data-v-2e19bb8c]{-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center}.my--selected .my__name[data-v-2e19bb8c]{background:#beebfa}.my__detail[data-v-2e19bb8c]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;width:100%;padding:5px 10px}.my__detail__column[data-v-2e19bb8c]{display:block;margin:5px 15px 5px 0}.my__input-score input[data-v-2e19bb8c]{width:4em;text-align:center}.my__score[data-v-2e19bb8c]{margin:5px 0 5px auto}.my__score__value--has[data-v-2e19bb8c]{font-size:171%}.my__score__value--active[data-v-2e19bb8c]{color:#0aa0d7}.my__select-type[data-v-2e19bb8c]{width:6.2em}.my__select-type select[disabled][data-v-2e19bb8c]{opacity:.5}.dn-manabi .my__select-type[data-v-2e19bb8c]{display:none!important}.my__action__btn[data-v-2e19bb8c]{min-width:8em}.my__child[data-v-2e19bb8c]{border-top:1px solid #adc4cc}.manabi-subject .my__action__btn[data-v-2e19bb8c]{min-width:0}@media (max-width:709px){.my__body[data-v-2e19bb8c]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}.my__name[data-v-2e19bb8c]{border-bottom:1px solid #adc4cc;padding:5px}.my__detail__column[data-v-2e19bb8c]{margin:5px 10px 5px 0}.my__score[data-v-2e19bb8c]{margin-left:auto}}@media (min-width:710px){.my__name[data-v-2e19bb8c]{border-right:1px solid #adc4cc;width:200px;padding:10px 5px;padding-right:0;flex-glow:0;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0}}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/js/jikosaiten/index/components/Subject.vue"],"names":[],"mappings":"AACA,wCAAwC,mBAAmB,aAAa,CACvE,AACD,+BAA+B,kBAAkB,CAChD,AACD,4BAA4B,eAAe,CAC1C,AACD,sDAAsD,oBAAoB,qBAAqB,oBAAoB,YAAY,CAC9H,AACD,2BAA2B,yBAAyB,2BAA2B,sBAAsB,kBAAkB,CACtH,AACD,yCAAyC,kBAAkB,CAC1D,AACD,6BAA6B,oBAAoB,qBAAqB,oBAAoB,aAAa,yBAAyB,2BAA2B,sBAAsB,mBAAmB,uBAAuB,mBAAmB,eAAe,WAAW,gBAAgB,CACvR,AACD,qCAAqC,cAAc,qBAAqB,CACvE,AACD,wCAAwC,UAAU,iBAAiB,CAClE,AACD,4BAA4B,qBAAqB,CAChD,AACD,wCAAwC,cAAc,CACrD,AACD,2CAA2C,aAAa,CACvD,AACD,kCAAkC,WAAW,CAC5C,AACD,mDAAmD,UAAU,CAC5D,AACD,6CAA6C,sBAAsB,CAClE,AACD,kCAAkC,aAAa,CAC9C,AACD,4BAA4B,4BAA4B,CACvD,AACD,kDAAkD,WAAW,CAC5D,AACD,yBACA,2BAA2B,4BAA4B,6BAA6B,8BAA8B,0BAA0B,qBAAqB,CAChK,AACD,2BAA2B,gCAAgC,WAAW,CACrE,AACD,qCAAqC,qBAAqB,CACzD,AACD,4BAA4B,gBAAgB,CAC3C,CACA,AACD,yBACA,2BAA2B,+BAA+B,YAAY,iBAAiB,gBAAgB,YAAY,sBAAsB,oBAAoB,aAAa,CACzK,CACA","file":"Subject.vue","sourcesContent":["\n.my[data-v-2e19bb8c]:not(.my--selected){background:#eff3f5;color:#adc4cc\n}\n.my--selected[data-v-2e19bb8c]{background:#fff5aa\n}\n.my--fixed[data-v-2e19bb8c]{background:#fff\n}\n.my__body[data-v-2e19bb8c],.my__name[data-v-2e19bb8c]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex\n}\n.my__name[data-v-2e19bb8c]{-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center\n}\n.my--selected .my__name[data-v-2e19bb8c]{background:#beebfa\n}\n.my__detail[data-v-2e19bb8c]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;width:100%;padding:5px 10px\n}\n.my__detail__column[data-v-2e19bb8c]{display:block;margin:5px 15px 5px 0\n}\n.my__input-score input[data-v-2e19bb8c]{width:4em;text-align:center\n}\n.my__score[data-v-2e19bb8c]{margin:5px 0 5px auto\n}\n.my__score__value--has[data-v-2e19bb8c]{font-size:171%\n}\n.my__score__value--active[data-v-2e19bb8c]{color:#0aa0d7\n}\n.my__select-type[data-v-2e19bb8c]{width:6.2em\n}\n.my__select-type select[disabled][data-v-2e19bb8c]{opacity:.5\n}\n.dn-manabi .my__select-type[data-v-2e19bb8c]{display:none!important\n}\n.my__action__btn[data-v-2e19bb8c]{min-width:8em\n}\n.my__child[data-v-2e19bb8c]{border-top:1px solid #adc4cc\n}\n.manabi-subject .my__action__btn[data-v-2e19bb8c]{min-width:0\n}\n@media (max-width:709px){\n.my__body[data-v-2e19bb8c]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column\n}\n.my__name[data-v-2e19bb8c]{border-bottom:1px solid #adc4cc;padding:5px\n}\n.my__detail__column[data-v-2e19bb8c]{margin:5px 10px 5px 0\n}\n.my__score[data-v-2e19bb8c]{margin-left:auto\n}\n}\n@media (min-width:710px){\n.my__name[data-v-2e19bb8c]{border-right:1px solid #adc4cc;width:200px;padding:10px 5px;padding-right:0;flex-glow:0;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0\n}\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 910:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ChildSubject = __webpack_require__(911);

var _ChildSubject2 = _interopRequireDefault(_ChildSubject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {

  components: {
    MyChildSubject: _ChildSubject2.default
  },

  props: {
    id: {
      type: String,
      required: true
    }
  },

  inject: ['resetCaliculateState'],

  data: function data() {
    return {
      innerDirectScore: null,
      directScoreBucket: {},
      directScoreChangesBucket: [],
      innerState: 'pending'
    };
  },


  computed: {
    classes: function classes() {
      var _ref;

      return _ref = {
        my: true
      }, _defineProperty(_ref, 'my--' + this.type, true), _defineProperty(_ref, 'my--selected', this.selected), _defineProperty(_ref, 'my--fixed', this.fixed), _ref;
    },
    data: function data() {
      return this.$store.getters['selfcheck/subjectOrChildById'](this.id);
    },
    name: function name() {
      return this.data.name;
    },
    max: function max() {
      return this.data.max;
    },
    children: function children() {
      return this.data.children;
    },


    inputDirectScore: {
      get: function get() {
        return this.innerDirectScore;
      },
      set: function set(val) {
        if (val === '' || val === null || val === undefined) {
          val = null;
        } else {
          val = parseFloat(val);
        }
        this.innerDirectScore = val;
      }
    },

    history: function history() {
      return this.$store.getters['selfcheck/subjectHistory'](this.id);
    },


    type: {
      get: function get() {
        return this.history.type;
      },
      set: function set(val) {
        var _this = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  _context.next = 2;
                  return _this.dispatchHistory({ type: val });

                case 2:
                  _this.resetCaliculateState && _this.resetCaliculateState();

                case 3:
                case 'end':
                  return _context.stop();
              }
            }
          }, _callee, _this);
        }))();
      }
    },
    selected: {
      get: function get() {
        return this.history.selected;
      },
      set: function set(val) {
        var _this2 = this;

        return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
          var selectedIds, index, errors, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, child;

          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  selectedIds = _this2.$store.getters['selfcheck/selectedSubjectIds'].slice();

                  if (val) {
                    if (!selectedIds.includes(_this2.id)) selectedIds.push(_this2.id);
                  } else {
                    index = selectedIds.indexOf(_this2.id);

                    if (index !== -1) selectedIds.splice(index, 1);
                  }
                  errors = _this2.$store.getters['selfcheck/subjectSelectionErrors'](selectedIds);

                  if (!errors) {
                    _context2.next = 6;
                    break;
                  }

                  dn.$alert(errors.map(function (error) {
                    return '\u30FB' + error;
                  }).join('\n'));
                  return _context2.abrupt('return', false);

                case 6:
                  if (!_this2.hasChild) {
                    _context2.next = 26;
                    break;
                  }

                  _iteratorNormalCompletion = true;
                  _didIteratorError = false;
                  _iteratorError = undefined;
                  _context2.prev = 10;

                  for (_iterator = _this2.children[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    child = _step.value;

                    _this2.dispatchHistory({ selected: val }, child.id);
                  }
                  _context2.next = 18;
                  break;

                case 14:
                  _context2.prev = 14;
                  _context2.t0 = _context2['catch'](10);
                  _didIteratorError = true;
                  _iteratorError = _context2.t0;

                case 18:
                  _context2.prev = 18;
                  _context2.prev = 19;

                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }

                case 21:
                  _context2.prev = 21;

                  if (!_didIteratorError) {
                    _context2.next = 24;
                    break;
                  }

                  throw _iteratorError;

                case 24:
                  return _context2.finish(21);

                case 25:
                  return _context2.finish(18);

                case 26:
                  _context2.next = 28;
                  return _this2.dispatchHistory({ selected: val });

                case 28:
                  _this2.resetCaliculateState && _this2.resetCaliculateState();

                case 29:
                case 'end':
                  return _context2.stop();
              }
            }
          }, _callee2, _this2, [[10, 14, 18, 26], [19,, 21, 25]]);
        }))();
      }
    },
    state: function state() {
      return this.history.state;
    },
    fixed: function fixed() {
      return this.history.fixed;
    },
    hasScore: function hasScore() {
      return this.history.hasScore;
    },
    isDirect: function isDirect() {
      return this.history.isDirect;
    },
    isSelfCheck: function isSelfCheck() {
      return this.history.isSelfCheck;
    },
    score: function score() {
      return this.history.score;
    },
    selfcheckScore: function selfcheckScore() {
      return this.history.selfcheckScore;
    },
    directScore: function directScore() {
      return this.history.directScore;
    },
    hasAnyScore: function hasAnyScore() {
      if (typeof this.inputDirectScore === 'number') return true;
      for (var id in this.directScoreBucket) {
        if (typeof this.directScoreBucket[id] === 'number') return true;
      }
      return false;
    },
    directScoreIsUpdated: function directScoreIsUpdated() {
      return this.inputDirectScore !== this.directScore;
    },
    anyDirectScoreIsUpdated: function anyDirectScoreIsUpdated() {
      return this.directScoreChangesBucket.length > 0;
    },
    hasChild: function hasChild() {
      return this.children.length > 0;
    }
  },

  watch: {
    state: function state(val) {
      this.$emit('change-state', val);
      this.resetCaliculateState && this.resetCaliculateState();
    },
    innerDirectScore: function innerDirectScore(val) {
      this.directScoreBucket[this.id] = val;
      this.resetCaliculateState && this.resetCaliculateState();
    },
    directScore: function directScore(val) {
      if (val !== this.innerDirectScore) this.innerDirectScore = val;
    },
    directScoreIsUpdated: function directScoreIsUpdated(val) {
      var bucket = this.directScoreChangesBucket;
      if (val) {
        if (!bucket.includes(this.id)) bucket.push(this.id);
      } else {
        var index = bucket.indexOf(this.id);
        if (index !== -1) bucket.splice(index, 1);
      }
    }
  },

  methods: {
    dispatchHistory: function dispatchHistory(data) {
      var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.id;

      return this.$store.dispatch('selfcheck/setSubjectHistory', { id: id, data: data });
    },
    onClickSubjectSelfCheck: function onClickSubjectSelfCheck() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this3.dispatchHistory({ selfCheckIsFinished: false });

              case 2:
                location.href = './' + _this3.id + '.html';

              case 3:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    storeDirectScore: function storeDirectScore() {
      var _this4 = this;

      if (!this.anyDirectScoreIsUpdated) return;

      var onInvalid = function onInvalid() {
        var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this4.name + '\u306E\u5165\u529B\u306B\u8AA4\u308A\u304C\u3042\u308A\u307E\u3059\u3002';

        dn.$alert(message);
      };

      var $children = this.$refs['child-subject'] || [];

      if (this.hasAnyScore) {

        // >>> いずれかの入力があるのでチェック
        var childrenDirectScores = $children.map(function (vm) {
          return vm.inputDirectScore;
        });
        var allDirectScore = [this.inputDirectScore].concat(_toConsumableArray(childrenDirectScores));

        // 最初に全数値が整数かつ、マイナスじゃないかのチェック
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = allDirectScore[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var score = _step2.value;

            if (score !== null && Math.abs(Math.round(score)) !== score) {
              return onInvalid();
              break;
            }
          }

          // 子科目を保有している場合、子科目の得点の合計が自分の科目点数と一致しているかチェック
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        if (this.hasChild) {
          var childrenTotal = childrenDirectScores.reduce(function (a, b) {
            return a + b;
          });
          if (this.inputDirectScore !== childrenTotal) {
            return onInvalid($children.map(function (vm) {
              return '\u300C' + vm.name + '\u300D';
            }).join('') + '\u306E\u5F97\u70B9\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002');
          }
        }
      }

      // 全部OKなので全部ストアする
      var $allVms = [this].concat(_toConsumableArray($children));
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = $allVms[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var vm = _step3.value;

          this.dispatchHistory({ directScore: vm.inputDirectScore }, vm.id);
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      this.$dn.blurActiveElement();
    },
    clearDirectScore: function clearDirectScore() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var $children, $allVms, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, vm;

        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return dn.$confirm('点数をクリアしてよろしいですか？');

              case 2:
                if (_context4.sent) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt('return');

              case 4:
                _this5.$dn.blurActiveElement();

                $children = _this5.$refs['child-subject'] || [];
                $allVms = [_this5].concat(_toConsumableArray($children));
                _iteratorNormalCompletion4 = true;
                _didIteratorError4 = false;
                _iteratorError4 = undefined;
                _context4.prev = 10;
                _iterator4 = $allVms[Symbol.iterator]();

              case 12:
                if (_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done) {
                  _context4.next = 20;
                  break;
                }

                vm = _step4.value;
                _context4.next = 16;
                return _this5.dispatchHistory({ directScore: null }, vm.id);

              case 16:
                vm.restoreDirectScore();

              case 17:
                _iteratorNormalCompletion4 = true;
                _context4.next = 12;
                break;

              case 20:
                _context4.next = 26;
                break;

              case 22:
                _context4.prev = 22;
                _context4.t0 = _context4['catch'](10);
                _didIteratorError4 = true;
                _iteratorError4 = _context4.t0;

              case 26:
                _context4.prev = 26;
                _context4.prev = 27;

                if (!_iteratorNormalCompletion4 && _iterator4.return) {
                  _iterator4.return();
                }

              case 29:
                _context4.prev = 29;

                if (!_didIteratorError4) {
                  _context4.next = 32;
                  break;
                }

                throw _iteratorError4;

              case 32:
                return _context4.finish(29);

              case 33:
                return _context4.finish(26);

              case 34:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this5, [[10, 22, 26, 34], [27,, 29, 33]]);
      }))();
    },
    restoreDirectScore: function restoreDirectScore() {
      this.inputDirectScore = this.history.directScore;
    }
  },

  created: function created() {
    this.restoreDirectScore();
  }
};

/***/ }),

/***/ 911:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(912)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(914),
  /* template */
  __webpack_require__(915),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-94622380",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 912:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(913);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("2f36a09e", content, true, {});

/***/ }),

/***/ 913:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(true);
// imports


// module
exports.push([module.i, ".my[data-v-94622380],.my__name[data-v-94622380]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex}.my__name[data-v-94622380]{-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center}.my--selected .my__name[data-v-94622380]{background:#beebfa}.my__detail[data-v-94622380]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;width:100%;padding:5px 10px}.my__detail__column[data-v-94622380]{display:block;margin:5px 15px 5px 0}.my__input-score input[data-v-94622380]{width:4em;text-align:center}.my__score[data-v-94622380]{margin:5px 0 5px auto}.my__score__value--has[data-v-94622380]{font-size:171%}.my__score__value--active[data-v-94622380]{color:#0aa0d7}.my .my__score__value[data-v-94622380]{font-size:inherit!important;color:#adc4cc!important}.dn-child-subject.my .my__name[data-v-94622380]{-webkit-box-pack:end;-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end;padding-right:10px}.dn-child-subject.my .my__input-score[data-v-94622380]{margin-left:calc(6.2em + 15px)}@media (max-width:709px){.my[data-v-94622380]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column}.my__name[data-v-94622380]{border-bottom:1px solid #adc4cc;padding:5px}.my__detail__column[data-v-94622380]{margin:5px 10px 5px 0}.my__score[data-v-94622380]{margin-left:auto}.dn-child-subject.my .my__input-score[data-v-94622380]{margin-left:calc(6.2em + 10px)}}@media (min-width:710px){.my__name[data-v-94622380]{border-right:1px solid #adc4cc;width:200px;padding:10px 5px;padding-right:0;flex-glow:0;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0}}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/js/jikosaiten/index/components/ChildSubject.vue"],"names":[],"mappings":"AACA,gDAAgD,oBAAoB,qBAAqB,oBAAoB,YAAY,CACxH,AACD,2BAA2B,yBAAyB,2BAA2B,sBAAsB,kBAAkB,CACtH,AACD,yCAAyC,kBAAkB,CAC1D,AACD,6BAA6B,oBAAoB,qBAAqB,oBAAoB,aAAa,yBAAyB,2BAA2B,sBAAsB,mBAAmB,uBAAuB,mBAAmB,eAAe,WAAW,gBAAgB,CACvR,AACD,qCAAqC,cAAc,qBAAqB,CACvE,AACD,wCAAwC,UAAU,iBAAiB,CAClE,AACD,4BAA4B,qBAAqB,CAChD,AACD,wCAAwC,cAAc,CACrD,AACD,2CAA2C,aAAa,CACvD,AACD,uCAAuC,4BAA4B,uBAAuB,CACzF,AACD,gDAAgD,qBAAqB,iCAAiC,kBAAkB,yBAAyB,kBAAkB,CAClK,AACD,uDAAuD,8BAA8B,CACpF,AACD,yBACA,qBAAqB,4BAA4B,6BAA6B,8BAA8B,0BAA0B,qBAAqB,CAC1J,AACD,2BAA2B,gCAAgC,WAAW,CACrE,AACD,qCAAqC,qBAAqB,CACzD,AACD,4BAA4B,gBAAgB,CAC3C,AACD,uDAAuD,8BAA8B,CACpF,CACA,AACD,yBACA,2BAA2B,+BAA+B,YAAY,iBAAiB,gBAAgB,YAAY,sBAAsB,oBAAoB,aAAa,CACzK,CACA","file":"ChildSubject.vue","sourcesContent":["\n.my[data-v-94622380],.my__name[data-v-94622380]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex\n}\n.my__name[data-v-94622380]{-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center\n}\n.my--selected .my__name[data-v-94622380]{background:#beebfa\n}\n.my__detail[data-v-94622380]{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;-webkit-box-align:center;-webkit-align-items:center;-ms-flex-align:center;align-items:center;-webkit-flex-wrap:wrap;-ms-flex-wrap:wrap;flex-wrap:wrap;width:100%;padding:5px 10px\n}\n.my__detail__column[data-v-94622380]{display:block;margin:5px 15px 5px 0\n}\n.my__input-score input[data-v-94622380]{width:4em;text-align:center\n}\n.my__score[data-v-94622380]{margin:5px 0 5px auto\n}\n.my__score__value--has[data-v-94622380]{font-size:171%\n}\n.my__score__value--active[data-v-94622380]{color:#0aa0d7\n}\n.my .my__score__value[data-v-94622380]{font-size:inherit!important;color:#adc4cc!important\n}\n.dn-child-subject.my .my__name[data-v-94622380]{-webkit-box-pack:end;-webkit-justify-content:flex-end;-ms-flex-pack:end;justify-content:flex-end;padding-right:10px\n}\n.dn-child-subject.my .my__input-score[data-v-94622380]{margin-left:calc(6.2em + 15px)\n}\n@media (max-width:709px){\n.my[data-v-94622380]{-webkit-box-orient:vertical;-webkit-box-direction:normal;-webkit-flex-direction:column;-ms-flex-direction:column;flex-direction:column\n}\n.my__name[data-v-94622380]{border-bottom:1px solid #adc4cc;padding:5px\n}\n.my__detail__column[data-v-94622380]{margin:5px 10px 5px 0\n}\n.my__score[data-v-94622380]{margin-left:auto\n}\n.dn-child-subject.my .my__input-score[data-v-94622380]{margin-left:calc(6.2em + 10px)\n}\n}\n@media (min-width:710px){\n.my__name[data-v-94622380]{border-right:1px solid #adc4cc;width:200px;padding:10px 5px;padding-right:0;flex-glow:0;-webkit-flex-shrink:0;-ms-flex-negative:0;flex-shrink:0\n}\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 914:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  props: {
    value: String,
    id: {
      type: String,
      required: true
    },
    type: String,
    selected: Boolean,
    fixed: Boolean,
    directScoreBucket: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    directScoreChangesBucket: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },

  inject: ['resetCaliculateState'],

  data: function data() {
    return {
      innerDirectScore: null
    };
  },


  computed: {
    inputDirectScore: {
      get: function get() {
        return this.innerDirectScore;
      },
      set: function set(val) {
        if (val === '' || val === null || val === undefined) {
          val = null;
        } else {
          val = parseFloat(val);
        }
        this.innerDirectScore = val;
      }
    },

    classes: function classes() {
      var _ref;

      return _ref = {
        my: true
      }, _defineProperty(_ref, 'my--' + this.type, true), _defineProperty(_ref, 'my--selected', this.selected), _defineProperty(_ref, 'my--fixed', this.fixed), _ref;
    },
    data: function data() {
      return this.$store.getters['selfcheck/subjectOrChildById'](this.id);
    },
    name: function name() {
      return this.data.name;
    },
    max: function max() {
      return this.data.max;
    },
    isDirect: function isDirect() {
      return this.type === 'direct';
    },
    history: function history() {
      return this.$store.getters['selfcheck/subjectHistory'](this.id);
    },
    hasScore: function hasScore() {
      return this.history.hasScore;
    },
    score: function score() {
      return this.history.score;
    },
    selfcheckScore: function selfcheckScore() {
      return this.history.selfcheckScore;
    },
    directScore: function directScore() {
      return this.history.directScore;
    },
    directScoreIsUpdated: function directScoreIsUpdated() {
      return this.inputDirectScore !== this.directScore;
    }
  },

  watch: {
    innerDirectScore: function innerDirectScore(val) {
      var bucket = Object.assign({}, this.directScoreBucket, _defineProperty({}, this.id, val));
      this.$emit('updateDirectScoreBucket', bucket);
      this.resetCaliculateState && this.resetCaliculateState();
    },
    directScore: function directScore(val) {
      if (val !== this.innerDirectScore) this.innerDirectScore = val;
    },
    directScoreIsUpdated: function directScoreIsUpdated(val) {
      var bucket = this.directScoreChangesBucket.slice();
      if (val) {
        if (!bucket.includes(this.id)) bucket.push(this.id);
      } else {
        var index = bucket.indexOf(this.id);
        if (index !== -1) bucket.splice(index, 1);
      }
      this.$emit('updateDirectScoreChangesBucket', bucket);
    }
  },

  methods: {
    restoreDirectScore: function restoreDirectScore() {
      this.inputDirectScore = this.directScore;
    },
    onSubmitDirectScore: function onSubmitDirectScore() {
      this.$emit('submit-directscore');
    }
  },

  created: function created() {
    this.restoreDirectScore();
  }
};

/***/ }),

/***/ 915:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('dl', {
    staticClass: "my",
    class: [_vm.classes, {
      'dn-child-subject': !_vm.$store.getters['config/isManabi']
    }],
    attrs: {
      "id": ("subject-" + _vm.id)
    }
  }, [(_vm.$store.getters['config/isManabi']) ? [_c('dt', {
    staticClass: "my__name"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('dd', {
    staticClass: "my__detail"
  }, [_c('form', {
    staticClass: "my__detail__column my__input-score",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmitDirectScore($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputDirectScore),
      expression: "inputDirectScore"
    }, {
      name: "number-range",
      rawName: "v-number-range"
    }],
    attrs: {
      "type": "tel",
      "number": "",
      "min": "0",
      "max": _vm.max,
      "disabled": !_vm.selected
    },
    domProps: {
      "value": (_vm.inputDirectScore)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputDirectScore = $event.target.value
      }
    }
  }), _vm._v("\n        点\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "my__detail__column my__score"
  }, [_c('span', {
    staticClass: "my__score__value",
    class: {
      'my__score__value--has': _vm.hasScore,
      'my__score__value--active': _vm.hasScore && _vm.selected,
    }
  }, [_vm._v(_vm._s(_vm.hasScore ? _vm.score : '---'))]), _vm._v("/"), _c('span', {
    staticClass: "my__score__max"
  }, [_vm._v(_vm._s(_vm.max) + "点")])])])] : [_c('dt', {
    staticClass: "my__name"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('dd', {
    staticClass: "my__detail"
  }, [(_vm.isDirect) ? _c('form', {
    staticClass: "my__detail__column my__input-score",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmitDirectScore($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputDirectScore),
      expression: "inputDirectScore"
    }, {
      name: "number-range",
      rawName: "v-number-range"
    }],
    attrs: {
      "type": "tel",
      "number": "",
      "min": "0",
      "max": _vm.max,
      "disabled": !_vm.selected
    },
    domProps: {
      "value": (_vm.inputDirectScore)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputDirectScore = $event.target.value
      }
    }
  }), _vm._v("\n      点\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "my__detail__column my__score"
  }, [_c('span', {
    staticClass: "my__score__value",
    class: {
      'my__score__value--has': _vm.hasScore,
      'my__score__value--active': _vm.hasScore && _vm.selected,
    }
  }, [_vm._v(_vm._s(_vm.hasScore ? _vm.score + '点' : '---'))]), _vm._v(" "), _c('span', {
    staticClass: "my__score__separator"
  }, [_vm._v("/")]), _vm._v(" "), _c('span', {
    staticClass: "my__score__max"
  }, [_vm._v(_vm._s(_vm.max) + "点")])])])]], 2)
},staticRenderFns: []}

/***/ }),

/***/ 916:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my",
    class: [_vm.classes, {
      'manabi-subject': _vm.$store.getters['config/isManabi']
    }],
    attrs: {
      "id": ("subject-" + _vm.id)
    }
  }, [(_vm.$store.getters['config/isManabi']) ? [_c('dl', {
    staticClass: "my__body"
  }, [_c('dt', {
    staticClass: "my__name"
  }, [_c('dn-chk-btn', {
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_vm._v(_vm._s(_vm.name))])], 1), _vm._v(" "), _c('dd', {
    staticClass: "my__detail"
  }, [_c('div', {
    staticClass: "my__detail__column my__select-type"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "disabled": !_vm.selected
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "selfcheck"
    }
  }, [_vm._v("解答入力")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "direct"
    }
  }, [_vm._v("点数入力")])])]), _vm._v(" "), _c('form', {
    staticClass: "my__detail__column my__input-score",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.storeDirectScore($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputDirectScore),
      expression: "inputDirectScore"
    }, {
      name: "number-range",
      rawName: "v-number-range"
    }],
    attrs: {
      "type": "tel",
      "number": "",
      "min": "0",
      "max": _vm.max,
      "disabled": !_vm.selected
    },
    domProps: {
      "value": (_vm.inputDirectScore)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputDirectScore = $event.target.value
      }
    }
  }), _vm._v("\n          点\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "my__detail__column my__action"
  }, [_c('dn-btn', {
    key: ("my__action__btn--" + _vm.type),
    staticClass: "my__action__btn",
    attrs: {
      "accent": "",
      "sm": "",
      "disabled": !_vm.selected || !_vm.anyDirectScoreIsUpdated
    },
    on: {
      "click": _vm.storeDirectScore
    }
  }, [_vm._v("\n            登録\n          ")]), _vm._v(" "), _c('dn-btn', {
    key: ("my__action__btn--" + _vm.type + "--clear"),
    staticClass: "my__action__btn",
    attrs: {
      "sm": "",
      "disabled": !_vm.selected || !_vm.hasAnyScore
    },
    on: {
      "click": _vm.clearDirectScore
    }
  }, [_vm._v("\n            削除\n          ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "my__detail__column my__score"
  }, [_c('span', {
    staticClass: "my__score__value",
    class: {
      'my__score__value--has': _vm.hasScore,
      'my__score__value--active': _vm.hasScore && _vm.selected,
    }
  }, [_vm._v(_vm._s(_vm.hasScore ? _vm.score : '---'))]), _vm._v("/"), _c('span', {
    staticClass: "my__score__max"
  }, [_vm._v(_vm._s(_vm.max) + "点")])])])]), _vm._v(" "), (_vm.children.length) ? _c('div', {
    staticClass: "my__children"
  }, _vm._l((_vm.children), function(child) {
    return _c('my-child-subject', {
      key: child.id,
      ref: "child-subject",
      refInFor: true,
      staticClass: "my__child",
      attrs: {
        "id": child.id,
        "type": _vm.type,
        "selected": _vm.selected,
        "fixed": _vm.fixed,
        "direct-score-bucket": _vm.directScoreBucket,
        "directscore-changes-bucket": _vm.directScoreChangesBucket
      },
      on: {
        "updateDirectScoreBucket": function($event) {
          _vm.directScoreBucket = $event
        },
        "updateDirectScoreChangesBucket": function($event) {
          _vm.directScoreChangesBucket = $event
        },
        "submit-directscore": _vm.storeDirectScore
      }
    })
  })) : _vm._e()] : [_c('dl', {
    staticClass: "my__body"
  }, [_c('dt', {
    staticClass: "my__name"
  }, [_c('dn-chk-btn', {
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  }, [_vm._v(_vm._s(_vm.name))])], 1), _vm._v(" "), _c('dd', {
    staticClass: "my__detail"
  }, [_c('div', {
    staticClass: "my__detail__column my__select-type"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.type),
      expression: "type"
    }],
    attrs: {
      "disabled": !_vm.selected
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.type = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "selfcheck"
    }
  }, [_vm._v("解答入力")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "direct"
    }
  }, [_vm._v("点数入力")])])]), _vm._v(" "), (_vm.isDirect) ? _c('form', {
    staticClass: "my__detail__column my__input-score",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.storeDirectScore($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.inputDirectScore),
      expression: "inputDirectScore"
    }, {
      name: "number-range",
      rawName: "v-number-range"
    }],
    attrs: {
      "type": "tel",
      "number": "",
      "min": "0",
      "max": _vm.max,
      "disabled": !_vm.selected
    },
    domProps: {
      "value": (_vm.inputDirectScore)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.inputDirectScore = $event.target.value
      }
    }
  }), _vm._v("\n        点\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "my__detail__column my__action"
  }, [(_vm.isSelfCheck) ? _c('dn-btn', {
    key: ("my__action__btn--" + _vm.type),
    staticClass: "my__action__btn",
    attrs: {
      "accent": !_vm.fixed,
      "plain": _vm.fixed,
      "sm": "",
      "disabled": !_vm.selected,
      "href": ("./" + _vm.id + ".html")
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.onClickSubjectSelfCheck($event)
      }
    }
  }, [_c('dn-icon', {
    class: _vm.fixed || !_vm.selected ? 'is-disabled' : 'is-white',
    attrs: {
      "icon": "pen"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "mr10"
  }, [_vm._v(_vm._s(_vm.fixed ? '採点しなおす' : '採点'))])], 1) : _vm._e(), _vm._v(" "), (_vm.isDirect) ? _c('dn-btn', {
    key: ("my__action__btn--" + _vm.type),
    staticClass: "my__action__btn",
    attrs: {
      "accent": "",
      "sm": "",
      "disabled": !_vm.selected || !_vm.anyDirectScoreIsUpdated
    },
    on: {
      "click": _vm.storeDirectScore
    }
  }, [_vm._v("\n          登録\n        ")]) : _vm._e(), _vm._v(" "), (_vm.isDirect) ? _c('dn-btn', {
    key: ("my__action__btn--" + _vm.type + "--clear"),
    staticClass: "my__action__btn",
    attrs: {
      "sm": "",
      "disabled": !_vm.selected || !_vm.hasAnyScore
    },
    on: {
      "click": _vm.clearDirectScore
    }
  }, [_vm._v("\n          クリア\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "my__detail__column my__score"
  }, [_c('span', {
    staticClass: "my__score__value",
    class: {
      'my__score__value--has': _vm.hasScore,
      'my__score__value--active': _vm.hasScore && _vm.selected,
    }
  }, [_vm._v(_vm._s(_vm.hasScore ? _vm.score + '点' : '---'))]), _vm._v(" "), _c('span', {
    staticClass: "my__score__separator"
  }, [_vm._v("/")]), _vm._v(" "), _c('span', {
    staticClass: "my__score__max"
  }, [_vm._v(_vm._s(_vm.max) + "点")])])])]), _vm._v(" "), (_vm.children.length) ? _c('div', {
    staticClass: "my__children"
  }, _vm._l((_vm.children), function(child) {
    return _c('my-child-subject', {
      key: child.id,
      ref: "child-subject",
      refInFor: true,
      staticClass: "my__child",
      attrs: {
        "id": child.id,
        "type": _vm.type,
        "selected": _vm.selected,
        "fixed": _vm.fixed,
        "direct-score-bucket": _vm.directScoreBucket,
        "directscore-changes-bucket": _vm.directScoreChangesBucket
      },
      on: {
        "updateDirectScoreBucket": function($event) {
          _vm.directScoreBucket = $event
        },
        "updateDirectScoreChangesBucket": function($event) {
          _vm.directScoreChangesBucket = $event
        },
        "submit-directscore": _vm.storeDirectScore
      }
    })
  })) : _vm._e()]], 2)
},staticRenderFns: []}

/***/ }),

/***/ 917:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "my",
    attrs: {
      "id": ("category-" + _vm.id)
    }
  }, [_vm._l((_vm.subjects), function(subject) {
    return _c('div', {
      key: subject.id,
      staticClass: "my__anchor-point",
      attrs: {
        "id": ("a" + (subject.id))
      }
    })
  }), _vm._v(" "), _c('h2', {
    staticClass: "my__name mdTtl02"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), (_vm.id === '4') ? _c('p', {
    staticClass: "my__judgement-notes"
  }, [_vm._v("英語以外の外国語に得点を入力した場合は、「英語（リスニング）」の得点は入力できません。「英語（リスニング）テスト受験免除者」は、「英語（リーディング）」と同じ点数を「英語（リスニング）」に入力してください。")]) : _vm._e(), _vm._v(" "), (_vm.id === '8') ? _c('p', {
    staticClass: "my__judgement-notes"
  }, [_vm._v("「簿記・会計」「情報関係基礎」に得点を入力した場合は「数IIＢ」として自動的に集計し、合格可能性を判定します。")]) : _vm._e(), _vm._v(" "), (_vm.subjects.length) ? _c('div', {
    staticClass: "my__subjects",
    attrs: {
      "id": ("subjects-" + _vm.id)
    }
  }, _vm._l((_vm.subjects), function(subject) {
    return _c('my-subject', {
      key: subject.id,
      ref: "subjects",
      refInFor: true,
      staticClass: "my__subject",
      attrs: {
        "id": subject.id
      },
      on: {
        "change-state": function($event) {
          _vm.onChangeSubjectState(subject, $event)
        }
      }
    })
  })) : _vm._e(), _vm._v(" "), (_vm.firstChoiceSelectable) ? _c('div', {
    staticClass: "my__first-subject"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.firstChoice),
      expression: "firstChoice"
    }],
    staticClass: "my__first-subject__select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.firstChoice = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.name) + "受験なし")]), _vm._v(" "), _vm._l((_vm.firstChoiceSubjects), function(subject) {
    return (subject.fixed) ? _c('option', {
      key: subject.id,
      domProps: {
        "value": subject.id
      }
    }, [_vm._v(_vm._s(subject.name))]) : _vm._e()
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "my__first-subject__guide"
  }, [_vm._v("\n      " + _vm._s(_vm.name) + "の第1解答科目を選択してください。\n    ")])]) : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),

/***/ 918:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(919)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(921),
  /* template */
  __webpack_require__(922),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-7dbe75c5",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 919:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(920);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(3)("11b5ecd8", content, true, {});

/***/ }),

/***/ 920:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(true);
// imports


// module
exports.push([module.i, ".my__questionnaire[data-v-7dbe75c5]{margin-top:20px}.my__table th[data-v-7dbe75c5]{width:220px;max-width:40%;text-align:left}.my__choice[data-v-7dbe75c5]{display:inline-block;line-height:2}.my__choice[data-v-7dbe75c5]:not(:last-child){margin-right:20px}@media (max-width:709px){.my__table th[data-v-7dbe75c5]{width:40%}}@media (min-width:710px){.my__table td[data-v-7dbe75c5],.my__table th[data-v-7dbe75c5]{padding:15px}}", "", {"version":3,"sources":["/home/kss/proj/dn_source/src/js/jikosaiten/index/components/Option.vue"],"names":[],"mappings":"AACA,oCAAoC,eAAe,CAClD,AACD,+BAA+B,YAAY,cAAc,eAAe,CACvE,AACD,6BAA6B,qBAAqB,aAAa,CAC9D,AACD,8CAA8C,iBAAiB,CAC9D,AACD,yBACA,+BAA+B,SAAS,CACvC,CACA,AACD,yBACA,8DAA8D,YAAY,CACzE,CACA","file":"Option.vue","sourcesContent":["\n.my__questionnaire[data-v-7dbe75c5]{margin-top:20px\n}\n.my__table th[data-v-7dbe75c5]{width:220px;max-width:40%;text-align:left\n}\n.my__choice[data-v-7dbe75c5]{display:inline-block;line-height:2\n}\n.my__choice[data-v-7dbe75c5]:not(:last-child){margin-right:20px\n}\n@media (max-width:709px){\n.my__table th[data-v-7dbe75c5]{width:40%\n}\n}\n@media (min-width:710px){\n.my__table td[data-v-7dbe75c5],.my__table th[data-v-7dbe75c5]{padding:15px\n}\n}"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 921:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _prefs = __webpack_require__(149);

var _prefs2 = _interopRequireDefault(_prefs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _LIBERALS = [{ id: '1', name: '文系' }, { id: '2', name: '理系' }]; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

var _QUESTIONNAIRIES = [{ id: '1', name: '使いやすかった' }, { id: '2', name: '使いにくかった' }];

exports.default = {
  computed: {
    PREFS: function PREFS() {
      return _prefs2.default;
    },
    LIBERALS: function LIBERALS() {
      return _LIBERALS;
    },
    QUESTIONNAIRIES: function QUESTIONNAIRIES() {
      return _QUESTIONNAIRIES;
    },

    isUse: function isUse() {
      return !this.$store.getters['path/locationIsMatchBackup'] && !this.$store.getters['config/isManabi'];
    },
    liberalInputName: function liberalInputName() {
      return this._uid + '_selfcheck_liberal';
    },
    prefInputName: function prefInputName() {
      return this._uid + '_selfcheck_pref';
    },
    questionnaireInputName: function questionnaireInputName() {
      return this._uid + '_selfcheck_pref';
    },


    selectedLiberal: {
      get: function get() {
        return this.$ls.get('self_check_attributes.liberal', null);
      },
      set: function set(val) {
        return this.$ls.set('self_check_attributes.liberal', val);
      }
    },
    selectedPref: {
      get: function get() {
        return this.$ls.get('self_check_attributes.pref', null);
      },
      set: function set(val) {
        return this.$ls.set('self_check_attributes.pref', val);
      }
    },
    selectedQuestionnaire: {
      get: function get() {
        return this.$ls.get('self_check_attributes.questionnaire', null);
      },
      set: function set(val) {
        return this.$ls.set('self_check_attributes.questionnaire', val);
      }
    },
    targetValues: function targetValues() {
      return this.isUse ? {
        liberal: this.selectedLiberal,
        pref: this.selectedPref,
        questionnaire: this.selectedQuestionnaire
      } : {
        liberal: '9',
        pref: '99',
        questionnaire: '9'
      };
    },
    errors: function errors() {
      var errors = [];

      if (this.isUse) {
        if (this.selectedLiberal === null) errors.push('「文系/理系」が選択されていません');
        if (this.selectedPref === null) errors.push('「所属高校エリア」が選択されていません');
        if (this.selectedQuestionnaire === null) errors.push('「アンケート」が選択されていません');
      }

      return errors;
    },
    valid: function valid() {
      return !this.errors.length;
    }
  }
};

/***/ }),

/***/ 922:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isUse) ? _c('div', {
    staticClass: "my"
  }, [_c('section', {
    staticClass: "my__attributes"
  }, [_c('h2', {
    staticClass: "mdTtl02"
  }, [_vm._v("属性入力")]), _vm._v(" "), _c('table', {
    staticClass: "my__table dn-table"
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("文系/理系")]), _vm._v(" "), _c('td', _vm._l((_vm.LIBERALS), function(liberal) {
    return _c('label', {
      key: liberal.id,
      staticClass: "my__choice"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedLiberal),
        expression: "selectedLiberal"
      }],
      attrs: {
        "type": "radio",
        "name": _vm.liberalInputName
      },
      domProps: {
        "value": liberal.id,
        "checked": _vm._q(_vm.selectedLiberal, liberal.id)
      },
      on: {
        "change": function($event) {
          _vm.selectedLiberal = liberal.id
        }
      }
    }), _vm._v("\n              " + _vm._s(liberal.name) + "\n            ")])
  }))]), _vm._v(" "), _c('tr', [_c('th', [_vm._v("所属高校エリア")]), _vm._v(" "), _c('td', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedPref),
      expression: "selectedPref"
    }],
    attrs: {
      "name": _vm.prefInputName
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedPref = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("都道府県を選択")]), _vm._v(" "), _vm._l((_vm.PREFS), function(pref) {
    return _c('option', {
      key: pref.id,
      domProps: {
        "value": pref.id
      }
    }, [_vm._v(_vm._s(pref.name))])
  })], 2)])])])])]), _vm._v(" "), _c('section', {
    staticClass: "my__questionnaire"
  }, [_c('h3', {
    staticClass: "mdTtl03"
  }, [_vm._v("アンケート")]), _vm._v(" "), _c('table', {
    staticClass: "my__table dn-table"
  }, [_c('tbody', [_c('tr', [_vm._m(0), _vm._v(" "), _c('td', _vm._l((_vm.QUESTIONNAIRIES), function(item) {
    return _c('label', {
      key: item.id,
      staticClass: "my__choice"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedQuestionnaire),
        expression: "selectedQuestionnaire"
      }],
      attrs: {
        "type": "radio",
        "name": _vm.questionnaireInputName
      },
      domProps: {
        "value": item.id,
        "checked": _vm._q(_vm.selectedQuestionnaire, item.id)
      },
      on: {
        "change": function($event) {
          _vm.selectedQuestionnaire = item.id
        }
      }
    }), _vm._v("\n              " + _vm._s(item.name) + "\n            ")])
  }))])])])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("自己採点計算ツールは"), _c('wbr'), _vm._v("使いやすかったですか？")])
}]}

/***/ }),

/***/ 923:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'manabi-jikosaiten': _vm.$store.getters['config/isManabi']
    },
    attrs: {
      "id": "pg-app"
    }
  }, [(_vm.$store.getters['config/isManabi']) ? [(_vm.$store.getters['config/checkerOpenFlg']['jikosaiten'] === '0') ? [_vm._m(0)] : [(_vm.$store.getters['config/isManabi']) ? _c('div', {
    staticClass: "dn-tabs__items"
  }, [_c('div', {
    staticClass: "dn-tabs__content dn-tabs__content--active dn-tabs-top"
  }, [_c('p', {
    staticClass: "mb20"
  }, [_vm._v("「自己採点結果の取得」を押して、「ベネッセ・駿台 データネット」で提出した自己採点結果を登録しましょう。")]), _vm._v(" "), _c('div', {
    staticClass: "tar"
  }, [_c('dn-btn', {
    attrs: {
      "primary": ""
    },
    on: {
      "click": function($event) {
        _vm.getApiDataInit()
      }
    }
  }, [_vm._v("\n              自己採点結果の取得\n            ")])], 1), _vm._v(" "), _vm._m(1)])]) : _vm._e(), _vm._v(" "), (_vm.isLoaded && !_vm.$store.getters['config/isManabi']) ? _c('div', {
    staticClass: "pg-ready"
  }, [_c('div', {
    staticClass: "my__categories"
  }, _vm._l((_vm.categories), function(category) {
    return _c('my-category', {
      key: category.id,
      ref: "categories",
      refInFor: true,
      staticClass: "my__category",
      attrs: {
        "id": category.id
      }
    })
  })), _vm._v(" "), _c('my-option', {
    ref: "option",
    staticClass: "my__option"
  }), _vm._v(" "), _c('div', {
    staticClass: "my__total"
  }, [_c('dn-btn', {
    staticClass: "my__total__btn-calc",
    attrs: {
      "accent": "",
      "disabled": !_vm.isActiveBtnCalculate
    },
    on: {
      "click": _vm.onClickBtnCalculate
    }
  }, [_c('dn-icon', {
    class: {
      'is-white': _vm.isActiveBtnCalculate,
      'is-disabled': !_vm.isActiveBtnCalculate,
    },
    attrs: {
      "icon": "arrow-right"
    }
  }), _vm._v("\n            総合得点を計算する\n          ")], 1), _vm._v(" "), _c('hr', {
    staticClass: "my__total__separator"
  }), _vm._v(" "), _c('div', {
    ref: "calculateResult",
    staticClass: "my__total__result"
  }, [_c('div', [_vm._v("\n              あなたの総合得点は・・・・\n\n              "), (_vm.isCalculating) ? _c('dn-circle2', {
    staticClass: "my__total__loading",
    attrs: {
      "color": "#0aa0d7",
      "background": "rgba(0, 0, 0, 0.25)"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isCalculated) ? _c('div', {
    staticClass: "my__total__result__values"
  }, [_c('span', {
    staticClass: "my__total__result__value"
  }, [_vm._v(_vm._s(_vm.totalHistory.score))]), _vm._v("点\n                /"), _c('span', {
    staticClass: "my__total__result__max"
  }, [_vm._v(_vm._s(_vm.totalHistory.max))]), _vm._v("点です。\n              ")]) : _vm._e()], 1), _vm._v(" "), _c('dn-expand-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCalculated),
      expression: "isCalculated"
    }],
    ref: "areaRetry",
    staticClass: "my__total__area-retry"
  }, [_c('dn-btn', {
    staticClass: "my__total__btn-retry",
    attrs: {
      "accent": ""
    },
    on: {
      "click": _vm.onClickBtnReset
    }
  }, [_vm._v("再集計する")])], 1)])], 1), _vm._v(" "), _c('dn-btn', {
    staticClass: "my__btn-under my__btn-clear",
    attrs: {
      "plain": ""
    },
    on: {
      "click": _vm.onClickBtnClear
    }
  }, [_vm._v("計算結果を全てクリアしてやり直す")]), _vm._v(" "), _c('dn-btn', {
    directives: [{
      name: "linkset",
      rawName: "v-linkset",
      value: ('C36'),
      expression: "'C36'"
    }],
    staticClass: "my__btn-under my__btn-to-checker",
    attrs: {
      "accent": "",
      "href": "./hantei/index.html"
    }
  }, [_vm._v("合格可能性判定" + _vm._s(_vm.$store.getters['config/isManabi'] ? '' : '　判定チェッカー'))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.$store.getters['config/isManabi']) ? _c('div', {
    staticClass: "dn-tabs__bar"
  }, [_vm._m(2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "dn-tabs__items"
  }, [_c('div', {
    staticClass: "dn-tabs__content dn-tabs__content--active"
  }, [(_vm.isLoaded) ? _c('div', {
    staticClass: "pg-ready"
  }, [_c('div', {
    staticClass: "my__categories"
  }, _vm._l((_vm.categories), function(category) {
    return _c('my-category', {
      key: category.id,
      ref: "categories",
      refInFor: true,
      staticClass: "my__category",
      attrs: {
        "id": category.id
      }
    })
  })), _vm._v(" "), _c('my-option', {
    ref: "option",
    staticClass: "my__option"
  }), _vm._v(" "), _c('div', {
    staticClass: "my__total"
  }, [_c('dn-btn', {
    staticClass: "my__total__btn-calc",
    attrs: {
      "accent": "",
      "disabled": !_vm.isActiveBtnCalculate
    },
    on: {
      "click": _vm.onClickBtnCalculate
    }
  }, [_c('dn-icon', {
    class: {
      'is-white': _vm.isActiveBtnCalculate,
      'is-disabled': !_vm.isActiveBtnCalculate,
    },
    attrs: {
      "icon": "arrow-right"
    }
  }), _vm._v("\n                総合得点を計算する\n              ")], 1), _vm._v(" "), _c('hr', {
    staticClass: "my__total__separator"
  }), _vm._v(" "), _c('div', {
    ref: "calculateResult",
    staticClass: "my__total__result"
  }, [_c('div', [_vm._v("\n                  あなたの総合得点は・・・・\n\n                  "), (_vm.isCalculating) ? _c('dn-circle2', {
    staticClass: "my__total__loading",
    attrs: {
      "color": "#0aa0d7",
      "background": "rgba(0, 0, 0, 0.25)"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isCalculated) ? _c('div', {
    staticClass: "my__total__result__values"
  }, [_c('span', {
    staticClass: "my__total__result__value"
  }, [_vm._v(_vm._s(_vm.totalHistory.score))]), _vm._v("点\n                    /"), _c('span', {
    staticClass: "my__total__result__max"
  }, [_vm._v(_vm._s(_vm.totalHistory.max))]), _vm._v("点です。\n                  ")]) : _vm._e()], 1), _vm._v(" "), _c('dn-expand-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCalculated),
      expression: "isCalculated"
    }],
    ref: "areaRetry",
    staticClass: "my__total__area-retry"
  }, [_c('dn-btn', {
    staticClass: "my__total__btn-retry",
    attrs: {
      "accent": ""
    },
    on: {
      "click": _vm.onClickBtnReset
    }
  }, [_vm._v("再集計する")])], 1)])], 1), _vm._v(" "), _c('dn-btn', {
    staticClass: "my__btn-under my__btn-clear",
    attrs: {
      "plain": ""
    },
    on: {
      "click": _vm.onClickBtnClear
    }
  }, [_vm._v("計算結果を全てクリアしてやり直す")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('dn-dialog', {
    ref: "dialog-alert_success"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "my-body"
  }, [_vm._v("取得に成功しました。"), _c('br')]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('dn-btn', {
    attrs: {
      "block-sp": ""
    },
    on: {
      "click": function($event) {
        _vm.screenReload()
      }
    }
  }, [_vm._v("OK")])], 1)]), _vm._v(" "), _c('dn-dialog', {
    ref: "dialog-alert_noscore"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "my-body"
  }, [_vm._v("成績がありませんでした。")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('dn-btn', {
    attrs: {
      "block-sp": ""
    },
    on: {
      "click": function($event) {
        _vm.screenReload()
      }
    }
  }, [_vm._v("OK")])], 1)]), _vm._v(" "), _c('dn-dialog', {
    ref: "dialog-alert_scoreerr"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "my-body"
  }, [_vm._v("通信に失敗しました。")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('dn-btn', {
    attrs: {
      "block-sp": ""
    },
    on: {
      "click": function($event) {
        _vm.screenReload()
      }
    }
  }, [_vm._v("OK")])], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dn-tabs__items",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('dn-icon', {
    attrs: {
      "icon": "tri-down--lg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "dn-tabs__content dn-tabs__content--active dn-tabs__next"
  }, [_c('p', {
    staticClass: "mb10",
    staticStyle: {
      "font-size": "16px"
    }
  }, [_vm._v("次に、志望校を登録しましょう")]), _vm._v(" "), _c('dn-btn', {
    directives: [{
      name: "linkset",
      rawName: "v-linkset",
      value: ('C36'),
      expression: "'C36'"
    }],
    staticClass: "my__btn-under my__btn-to-checker",
    staticStyle: {
      "font-size": "14px"
    },
    attrs: {
      "accent": ""
    },
    on: {
      "click": function($event) {
        _vm.onClickBtnChecker('../bible/search/index.html')
      }
    }
  }, [_vm._v("STEP2 志望校の登録へ　＞＞")])], 1)], 1)]] : [_c('div', {
    staticClass: "tar"
  }, [(_vm.$store.getters['config/isManabi']) ? _c('dn-btn', {
    attrs: {
      "primary": ""
    },
    on: {
      "click": function($event) {
        _vm.getApiData()
      }
    }
  }, [_vm._v("\n        自己採点結果の取得\n        ")]) : _vm._e()], 1), _vm._v(" "), (_vm.isLoaded) ? _c('div', {
    staticClass: "pg-ready"
  }, [_c('div', {
    staticClass: "my__categories"
  }, _vm._l((_vm.categories), function(category) {
    return _c('my-category', {
      key: category.id,
      ref: "categories",
      refInFor: true,
      staticClass: "my__category",
      attrs: {
        "id": category.id
      }
    })
  })), _vm._v(" "), _c('my-option', {
    ref: "option",
    staticClass: "my__option"
  }), _vm._v(" "), _c('div', {
    staticClass: "my__total"
  }, [_c('dn-btn', {
    staticClass: "my__total__btn-calc",
    attrs: {
      "accent": "",
      "disabled": !_vm.isActiveBtnCalculate
    },
    on: {
      "click": _vm.onClickBtnCalculate
    }
  }, [_c('dn-icon', {
    class: {
      'is-white': _vm.isActiveBtnCalculate,
      'is-disabled': !_vm.isActiveBtnCalculate,
    },
    attrs: {
      "icon": "arrow-right"
    }
  }), _vm._v("\n          総合得点を計算する\n        ")], 1), _vm._v(" "), _c('hr', {
    staticClass: "my__total__separator"
  }), _vm._v(" "), _c('div', {
    ref: "calculateResult",
    staticClass: "my__total__result"
  }, [_c('div', [_vm._v("\n            あなたの総合得点は・・・・\n\n            "), (_vm.isCalculating) ? _c('dn-circle2', {
    staticClass: "my__total__loading",
    attrs: {
      "color": "#0aa0d7",
      "background": "rgba(0, 0, 0, 0.25)"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isCalculated) ? _c('div', {
    staticClass: "my__total__result__values"
  }, [_c('span', {
    staticClass: "my__total__result__value"
  }, [_vm._v(_vm._s(_vm.totalHistory.score))]), _vm._v("点\n              /"), _c('span', {
    staticClass: "my__total__result__max"
  }, [_vm._v(_vm._s(_vm.totalHistory.max))]), _vm._v("点です。\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('dn-expand-transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCalculated),
      expression: "isCalculated"
    }],
    ref: "areaRetry",
    staticClass: "my__total__area-retry"
  }, [_c('dn-btn', {
    staticClass: "my__total__btn-retry",
    attrs: {
      "accent": ""
    },
    on: {
      "click": _vm.onClickBtnReset
    }
  }, [_vm._v("再集計する")])], 1)])], 1), _vm._v(" "), _c('dn-btn', {
    staticClass: "my__btn-under my__btn-clear",
    attrs: {
      "plain": ""
    },
    on: {
      "click": _vm.onClickBtnClear
    }
  }, [_vm._v("計算結果を全てクリアしてやり直す")]), _vm._v(" "), _c('dn-btn', {
    directives: [{
      name: "linkset",
      rawName: "v-linkset",
      value: ('C36'),
      expression: "'C36'"
    }],
    staticClass: "my__btn-under my__btn-to-checker",
    attrs: {
      "accent": ""
    },
    on: {
      "click": function($event) {
        _vm.onClickBtnChecker('./hantei/index.html')
      }
    }
  }, [_vm._v("合格可能性判定" + _vm._s(_vm.$store.getters['config/isManabi'] ? '' : '　判定チェッカー'))])], 1)], 1) : _vm._e(), _vm._v(" "), _c('dn-dialog', {
    ref: "dialog-alert_noscore"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "my-body"
  }, [_vm._v("成績がありませんでした。")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('dn-btn', {
    staticStyle: {
      "margin-left": "7em"
    },
    attrs: {
      "block-sp": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.$refs['dialog-alert_noscore'].hide($event)
      }
    }
  }, [_vm._v("OK")])], 1)]), _vm._v(" "), _c('dn-dialog', {
    ref: "dialog-alert_scoreerr"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }), _vm._v(" "), _c('div', {
    staticClass: "my-body"
  }, [_vm._v("通信に失敗しました。")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('dn-btn', {
    staticStyle: {
      "margin-left": "7em"
    },
    attrs: {
      "block-sp": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.$refs['dialog-alert_scoreerr'].hide($event)
      }
    }
  }, [_vm._v("OK")])], 1)])]], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dn-tabs__items"
  }, [_c('div', {
    staticClass: "dn-tabs__content dn-tabs__content--active",
    staticStyle: {
      "border-top": "1px solid #adc4cc"
    }
  }, [_c('p', {
    staticClass: "mb20"
  }, [_vm._v("公開までしばらくお待ちください。"), _c('br'), _vm._v("\n            大学入学共通テストの解答を入力すると、自己採点結果を計算することができるツールです。")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("登録した内容で志望校の合格可能性判定を入力できます。"), _c('br'), _vm._v("自己採点結果が取得できない場合は、手動で受験結果を入力し、登録してください。")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dn-tabs__container"
  }, [_c('a', {
    staticClass: "dn-tabs__item",
    attrs: {
      "href": "../bible/mock/index.html"
    }
  }, [_vm._v("\n            進研模試 3年10月\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "dn-tabs__item dn-tabs__item--active",
    attrs: {
      "href": "./index.html"
    }
  }, [_vm._v("\n            自己採点\n          ")])])
}]}

/***/ })

/******/ });


// WEBPACK FOOTER //
// jikosaiten/js/index.js